// Auto-generated by /app/scripts/build_i18n.py
export const QUESTIONS = [
 {
  "id": 1,
  "category": "py-core",
  "q": "What is the output?\nprint(3 * '2' + '1')",
  "options": [
   "7",
   "'2221'",
   "2221",
   "'621'"
  ],
  "correctIndex": 2,
  "explanation": "'2' * 3 gives '222', and concatenating '1' gives '2221'; print shows it without quotes."
 },
 {
  "id": 2,
  "category": "py-core",
  "q": "What is the output?\ndef f(x, l=[]):\n    l.append(x)\n    return l\nprint(f(1), f(2))",
  "options": [
   "[1] [2]",
   "[1, 2] [1, 2]",
   "[1] [1, 2]",
   "[1, 2] [2]"
  ],
  "correctIndex": 1,
  "explanation": "The default list is created once and shared across calls, so both calls return the same list object, [1, 2]."
 },
 {
  "id": 3,
  "category": "py-core",
  "q": "What is the output?\nprint(10 // 3, -10 // 3)",
  "options": [
   "3 -3",
   "3 -4",
   "4 -4",
   "3.33 -3.33"
  ],
  "correctIndex": 1,
  "explanation": "Floor division rounds toward negative infinity, so -10 // 3 is -4."
 },
 {
  "id": 4,
  "category": "py-core",
  "q": "What is the output?\na = [1, 2, 3]\nb = a\nb.append(4)\nprint(a)",
  "options": [
   "[1, 2, 3]",
   "[4]",
   "[1, 2, 3, 4]",
   "Error"
  ],
  "correctIndex": 2,
  "explanation": "b and a refer to the same list object, so mutation through b is visible through a."
 },
 {
  "id": 5,
  "category": "py-core",
  "q": "What is the output?\nprint(bool([]), bool([0]), bool(''))",
  "options": [
   "False True False",
   "True True False",
   "False False False",
   "False True True"
  ],
  "correctIndex": 0,
  "explanation": "Empty containers and empty strings are falsy; a non-empty list, even [0], is truthy."
 },
 {
  "id": 6,
  "category": "py-core",
  "q": "What is the output?\nt = (1, [2, 3])\nt[1].append(4)\nprint(t)",
  "options": [
   "TypeError",
   "(1, [2, 3])",
   "(1, [2, 3], 4)",
   "(1, [2, 3, 4])"
  ],
  "correctIndex": 3,
  "explanation": "The tuple itself is immutable, but the list inside it is mutable and can be modified in place."
 },
 {
  "id": 7,
  "category": "py-core",
  "q": "What is the output?\nprint('python'[1:5:2])",
  "options": [
   "yh",
   "yhn",
   "pt",
   "yt"
  ],
  "correctIndex": 0,
  "explanation": "Slice [1:5:2] takes indices 1 and 3, which are 'y' and 'h'."
 },
 {
  "id": 8,
  "category": "py-core",
  "q": "Which of the following can be used as a dictionary key in Python?",
  "options": [
   "[1, 2]",
   "{1, 2}",
   "{'a': 1}",
   "(1, 2)"
  ],
  "correctIndex": 3,
  "explanation": "Keys must be hashable. Tuples of hashable items are hashable; lists, sets and dicts are not."
 },
 {
  "id": 9,
  "category": "py-core",
  "q": "What is the output?\nprint(0.1 + 0.2 == 0.3)",
  "options": [
   "True",
   "False",
   "Error",
   "None"
  ],
  "correctIndex": 1,
  "explanation": "Binary floating-point representation makes 0.1 + 0.2 equal 0.30000000000000004, not 0.3."
 },
 {
  "id": 10,
  "category": "py-core",
  "q": "What happens when this runs?\nx = 5\ndef f():\n    print(x)\n    x = 3\nf()",
  "options": [
   "Prints 5",
   "Prints 3",
   "UnboundLocalError",
   "NameError at module level"
  ],
  "correctIndex": 2,
  "explanation": "Assigning x inside f makes it local for the whole function, so print(x) reads it before assignment."
 },
 {
  "id": 11,
  "category": "py-core",
  "q": "What is the output?\ng = (i * i for i in range(3))\nprint(list(g), list(g))",
  "options": [
   "[0, 1, 4] [0, 1, 4]",
   "[0, 1, 4] []",
   "[] []",
   "[0, 1, 4] None"
  ],
  "correctIndex": 1,
  "explanation": "A generator is exhausted after one full iteration, so the second list() call returns an empty list."
 },
 {
  "id": 12,
  "category": "py-core",
  "q": "What is the output?\nprint(set([1, 2, 2, 3]) & {2, 3, 4})",
  "options": [
   "{1, 2, 3, 4}",
   "{2, 3}",
   "{1}",
   "{2, 2, 3}"
  ],
  "correctIndex": 1,
  "explanation": "The & operator gives the set intersection, which is {2, 3}; duplicates are removed."
 },
 {
  "id": 13,
  "category": "py-core",
  "q": "What is the output?\na = [1]\nb = [1]\nprint(a == b, a is b)",
  "options": [
   "True True",
   "False False",
   "False True",
   "True False"
  ],
  "correctIndex": 3,
  "explanation": "== compares values (equal), while is compares identity (two separate list objects)."
 },
 {
  "id": 14,
  "category": "py-core",
  "q": "What is the output?\nfs = [lambda: i for i in range(3)]\nprint([f() for f in fs])",
  "options": [
   "[0, 1, 2]",
   "[2, 2, 2]",
   "[0, 0, 0]",
   "[3, 3, 3]"
  ],
  "correctIndex": 1,
  "explanation": "Closures capture the variable i, not its value, so all lambdas see its final value of 2."
 },
 {
  "id": 15,
  "category": "py-core",
  "q": "What is the output?\nprint(sorted(['b', 'A', 'c'], key=str.lower))",
  "options": [
   "['A', 'b', 'c']",
   "['A', 'c', 'b']",
   "['b', 'A', 'c']",
   "['c', 'b', 'A']"
  ],
  "correctIndex": 0,
  "explanation": "Sorting uses lowercase keys 'b','a','c', giving the order A, b, c while keeping the original items."
 },
 {
  "id": 16,
  "category": "py-core",
  "q": "In CPython, what does the Global Interpreter Lock (GIL) ensure?",
  "options": [
   "Only one thread executes Python bytecode at a time",
   "Each thread gets its own interpreter",
   "Processes cannot run in parallel",
   "Variables are always thread-safe"
  ],
  "correctIndex": 0,
  "explanation": "The GIL lets only one thread run Python bytecode at a time, limiting CPU-bound multithreading."
 },
 {
  "id": 17,
  "category": "py-core",
  "q": "What is the output?\ndef f(a, *args, **kw):\n    print(a, args, kw)\nf(1, 2, 3, x=4)",
  "options": [
   "1 (2, 3) {'x': 4}",
   "1 [2, 3] {'x': 4}",
   "1 2 3 {'x': 4}",
   "1 (2, 3, 4) {}"
  ],
  "correctIndex": 0,
  "explanation": "Extra positional arguments are collected as a tuple in *args and keyword arguments as a dict in **kw."
 },
 {
  "id": 18,
  "category": "py-core",
  "q": "What does this return?\ndef f():\n    try:\n        return 1\n    finally:\n        return 2\nprint(f())",
  "options": [
   "1",
   "2",
   "None",
   "Error"
  ],
  "correctIndex": 1,
  "explanation": "The return in the finally block always runs last and overrides the earlier return value."
 },
 {
  "id": 19,
  "category": "py-core",
  "q": "What is the output?\nprint(len({1: 'a', 1.0: 'b', True: 'c'}))",
  "options": [
   "3",
   "2",
   "1",
   "Error"
  ],
  "correctIndex": 2,
  "explanation": "1, 1.0 and True are equal with the same hash, so they are the same key; the value ends up 'c'."
 },
 {
  "id": 20,
  "category": "py-core",
  "q": "What is the output?\na = [[1], [2]]\nb = a.copy()\nb[0].append(9)\nprint(a)",
  "options": [
   "[[1], [2]]",
   "[[1, 9], [2]]",
   "[[1, 9], [2, 9]]",
   "[[9], [2]]"
  ],
  "correctIndex": 1,
  "explanation": "copy() is shallow, so the inner lists are shared and a change through b is visible in a."
 },
 {
  "id": 21,
  "category": "py-core",
  "q": "What is the output?\nprint(type(5 / 2), 5 // 2)",
  "options": [
   "<class 'int'> 2",
   "<class 'float'> 2",
   "<class 'float'> 2.5",
   "<class 'int'> 2.5"
  ],
  "correctIndex": 1,
  "explanation": "In Python 3, / always returns a float (2.5), while // floors the result to 2, so type(5/2) is float."
 },
 {
  "id": 22,
  "category": "py-core",
  "q": "What happens when this runs?\ns = 'hello'\ns[0] = 'H'\nprint(s)",
  "options": [
   "Hello",
   "hello",
   "TypeError",
   "IndexError"
  ],
  "correctIndex": 2,
  "explanation": "Strings are immutable, so item assignment raises TypeError."
 },
 {
  "id": 23,
  "category": "py-core",
  "q": "What is the output?\nprint([1, 2, 3][::-1], 'abc'[-1])",
  "options": [
   "[3, 2, 1] c",
   "[1, 2, 3] c",
   "[3, 2, 1] a",
   "[3, 2] c"
  ],
  "correctIndex": 0,
  "explanation": "A step of -1 reverses the list, and index -1 gives the last character 'c'."
 },
 {
  "id": 24,
  "category": "py-core",
  "q": "What is the output?\nd = {'a': 1}\nprint(d.get('b', 0), d.setdefault('b', 5), d)",
  "options": [
   "0 5 {'a': 1}",
   "0 0 {'a': 1, 'b': 0}",
   "None 5 {'a': 1, 'b': 5}",
   "0 5 {'a': 1, 'b': 5}"
  ],
  "correctIndex": 3,
  "explanation": "get returns the default 0 without inserting; setdefault inserts 'b':5 and returns 5, and d is printed after both calls run."
 },
 {
  "id": 25,
  "category": "py-core",
  "q": "What is the output?\nprint(-7 % 3, 7 % -3)",
  "options": [
   "-1 1",
   "2 -2",
   "2 2",
   "-1 -2"
  ],
  "correctIndex": 1,
  "explanation": "Python's modulo takes the sign of the divisor: -7 % 3 = 2 and 7 % -3 = -2."
 },
 {
  "id": 26,
  "category": "py-core",
  "q": "What is the output?\na = [1]; b = a; a += [2]\nc = (1,); d = c; c += (2,)\nprint(b, d)",
  "options": [
   "[1] (1,)",
   "[1, 2] (1, 2)",
   "[1, 2] (1,)",
   "[1] (1, 2)"
  ],
  "correctIndex": 2,
  "explanation": "+= mutates a list in place so b sees the change; tuples are immutable so c is rebound to a new tuple and d is unchanged."
 },
 {
  "id": 27,
  "category": "py-core",
  "q": "In a decorator, what is the main purpose of using functools.wraps(func) on the inner wrapper?",
  "options": [
   "Preserve the original function's metadata such as __name__ and __doc__",
   "Make the decorated function run faster",
   "Allow the wrapper to accept any arguments",
   "Prevent the function from being called twice"
  ],
  "correctIndex": 0,
  "explanation": "functools.wraps copies __name__, __doc__ and other attributes from the wrapped function onto the wrapper."
 },
 {
  "id": 28,
  "category": "py-core",
  "q": "What is the output?\nprint(any([]), all([]))",
  "options": [
   "True True",
   "False False",
   "True False",
   "False True"
  ],
  "correctIndex": 3,
  "explanation": "any of an empty iterable is False (no truthy element), while all of an empty iterable is vacuously True."
 },
 {
  "id": 29,
  "category": "py-core",
  "q": "What is the output?\nclass A:\n    x = []\na = A()\nb = A()\na.x.append(1)\nprint(b.x)",
  "options": [
   "[]",
   "[1]",
   "AttributeError",
   "None"
  ],
  "correctIndex": 1,
  "explanation": "x is a class attribute shared by all instances; append mutates the same list, so b.x shows [1]."
 },
 {
  "id": 30,
  "category": "py-core",
  "q": "What is the output?\nprint(round(2.5), round(3.5), round(-0.5))",
  "options": [
   "3 4 -0",
   "2 4 -1",
   "2 4 0",
   "3 3 0"
  ],
  "correctIndex": 2,
  "explanation": "Python 3 uses banker's rounding (round half to even): 2.5 -> 2, 3.5 -> 4, -0.5 -> 0 (an int)."
 },
 {
  "id": 31,
  "category": "py-core",
  "q": "What is the output?\ndef gen():\n    yield 1\n    yield 2\ng = gen()\nprint(next(g), next(g), next(g, 'end'))",
  "options": [
   "1 2 end",
   "1 2 None",
   "StopIteration is raised",
   "1 1 end"
  ],
  "correctIndex": 0,
  "explanation": "After the generator is exhausted, next() returns the supplied default 'end' instead of raising StopIteration."
 },
 {
  "id": 32,
  "category": "py-core",
  "q": "What is the output?\nprint('a' in 'abc', 'ac' in 'abc', '' in 'abc')",
  "options": [
   "True True True",
   "True False False",
   "False False True",
   "True False True"
  ],
  "correctIndex": 3,
  "explanation": "'in' on strings tests for a contiguous substring: 'ac' is not contiguous, and the empty string is always a substring."
 },
 {
  "id": 33,
  "category": "py-core",
  "q": "What is the output?\ndef f():\n    try:\n        print('t')\n    except:\n        print('e')\n    else:\n        print('a')\n    finally:\n        print('f')\nf()",
  "options": [
   "t f",
   "t a f",
   "t e f",
   "t a"
  ],
  "correctIndex": 1,
  "explanation": "With no exception, try runs, then else runs, and finally always runs last: t a f."
 },
 {
  "id": 34,
  "category": "py-core",
  "q": "What is the output?\nprint(list(zip([1, 2, 3], 'ab')))",
  "options": [
   "[(1,'a'),(2,'b'),(3,None)]",
   "Error",
   "[(1, 'a'), (2, 'b')]",
   "[(1, 'a'), (2, 'b'), (3,)]"
  ],
  "correctIndex": 2,
  "explanation": "zip stops at the shortest iterable, so the extra element 3 is dropped."
 },
 {
  "id": 35,
  "category": "py-core",
  "q": "What is the output?\nprint(*[1, 2, 3], sep='-')",
  "options": [
   "1-2-3",
   "1 2 3",
   "[1-2-3]",
   "SyntaxError"
  ],
  "correctIndex": 0,
  "explanation": "The * operator unpacks the list into separate arguments and sep='-' joins them with hyphens."
 },
 {
  "id": 36,
  "category": "py-core",
  "q": "Which operation on a Python list of n elements takes O(n) time?",
  "options": [
   "lst.append(x)",
   "lst[5]",
   "len(lst)",
   "lst.insert(0, x)"
  ],
  "correctIndex": 3,
  "explanation": "Inserting at the front shifts all existing elements, which is O(n); append (amortized), indexing and len are O(1)."
 },
 {
  "id": 37,
  "category": "py-core",
  "q": "What is the output?\ndef outer():\n    x = 1\n    def inner():\n        nonlocal x\n        x += 1\n    inner()\n    return x\nprint(outer())",
  "options": [
   "1",
   "2",
   "UnboundLocalError",
   "SyntaxError"
  ],
  "correctIndex": 1,
  "explanation": "nonlocal lets inner rebind outer's x, so x becomes 2."
 },
 {
  "id": 38,
  "category": "py-core",
  "q": "What is the output?\na = [1, 2, 3, 4]\na[1:3] = [9]\nprint(a)",
  "options": [
   "[1, 9, 9, 4]",
   "[1, [9], 4]",
   "[1, 9, 4]",
   "[9, 4]"
  ],
  "correctIndex": 2,
  "explanation": "Slice assignment replaces elements at indices 1 and 2 with the items of the right-hand iterable, and the size can change."
 },
 {
  "id": 39,
  "category": "py-core",
  "q": "What is the output?\nprint('a,b,,c'.split(','))",
  "options": [
   "['a', 'b', '', 'c']",
   "['a', 'b', 'c']",
   "['a', 'b', ' ', 'c']",
   "['a,b,,c']"
  ],
  "correctIndex": 0,
  "explanation": "With an explicit separator, split keeps empty strings between consecutive separators."
 },
 {
  "id": 40,
  "category": "py-core",
  "q": "What is the output?\nclass P:\n    def __eq__(self, o):\n        return True\nprint(len({P()}))",
  "options": [
   "1",
   "0",
   "AttributeError",
   "TypeError"
  ],
  "correctIndex": 3,
  "explanation": "Defining __eq__ without __hash__ sets __hash__ to None, making instances unhashable so they cannot go in a set."
 },
 {
  "id": 41,
  "category": "py-ds",
  "q": "What is the output?\nt = (1, 2, [3, 4])\nt[2].append(5)\nprint(t)",
  "options": [
   "TypeError",
   "(1, 2, [3, 4])",
   "(1, 2, [3, 4, 5])",
   "(1, 2, 3, 4, 5)"
  ],
  "correctIndex": 2,
  "explanation": "The tuple cannot be rebound, but the list inside it is mutable and can change in place."
 },
 {
  "id": 42,
  "category": "py-ds",
  "q": "What is the type of x in: x = {} ?",
  "options": [
   "set",
   "dict",
   "tuple",
   "list"
  ],
  "correctIndex": 1,
  "explanation": "Empty braces create a dict; use set() for an empty set."
 },
 {
  "id": 43,
  "category": "py-ds",
  "q": "What does d.get('c', 0) return for d = {'a': 1, 'b': 2}?",
  "options": [
   "KeyError",
   "None",
   "0",
   "'c'"
  ],
  "correctIndex": 2,
  "explanation": "get returns the supplied default when the key is missing, without raising KeyError."
 },
 {
  "id": 44,
  "category": "py-ds",
  "q": "What is the output?\nprint([1, 2, 3, 4, 5][::-2])",
  "options": [
   "[5, 3, 1]",
   "[1, 3, 5]",
   "[5, 4, 3, 2, 1]",
   "[4, 2]"
  ],
  "correctIndex": 0,
  "explanation": "A step of -2 starts from the end and takes every second element: 5, 3, 1."
 },
 {
  "id": 45,
  "category": "py-ds",
  "q": "What is the output?\nprint({1, 2, 3} ^ {3, 4})",
  "options": [
   "{3}",
   "{1, 2, 3, 4}",
   "{1, 2}",
   "{1, 2, 4}"
  ],
  "correctIndex": 3,
  "explanation": "^ is symmetric difference: elements in exactly one of the two sets, so 3 is excluded."
 },
 {
  "id": 46,
  "category": "py-ds",
  "q": "What is the output?\ndef f(x, l=[]):\n    l.append(x)\n    return l\nf(1)\nprint(f(2))",
  "options": [
   "[2]",
   "[1]",
   "[1, 2]",
   "[1, 2, 2]"
  ],
  "correctIndex": 2,
  "explanation": "The default list is created once at definition time and shared across calls."
 },
 {
  "id": 47,
  "category": "py-ds",
  "q": "What happens when you run: d = {[1, 2]: 'x'} ?",
  "options": [
   "Creates the dict",
   "TypeError: unhashable type: 'list'",
   "KeyError",
   "Creates {1: 'x', 2: 'x'}"
  ],
  "correctIndex": 1,
  "explanation": "Dict keys must be hashable; lists are mutable and therefore unhashable."
 },
 {
  "id": 48,
  "category": "py-ds",
  "q": "Average time complexity of 'x in s' for a list s of n items versus a set s of n items?",
  "options": [
   "O(n) vs O(1)",
   "O(1) vs O(1)",
   "O(log n) vs O(1)",
   "O(n) vs O(n)"
  ],
  "correctIndex": 0,
  "explanation": "Lists scan linearly, while sets use hashing for average constant-time lookup."
 },
 {
  "id": 49,
  "category": "py-ds",
  "q": "What is the output?\nprint([x*x for x in range(5) if x % 2 == 0])",
  "options": [
   "[0, 1, 4, 9, 16]",
   "[1, 9]",
   "[0, 2, 4]",
   "[0, 4, 16]"
  ],
  "correctIndex": 3,
  "explanation": "Only the even x values 0, 2, 4 pass the filter, giving squares 0, 4, 16."
 },
 {
  "id": 50,
  "category": "py-ds",
  "q": "What is type((5)) in Python 3?",
  "options": [
   "tuple",
   "int",
   "list",
   "NoneType"
  ],
  "correctIndex": 1,
  "explanation": "Parentheses alone just group; a one-element tuple needs a trailing comma, as in (5,)."
 },
 {
  "id": 51,
  "category": "py-ds",
  "q": "What is the output?\nd = {}\nd[1] = 'a'\nd[True] = 'b'\nprint(d)",
  "options": [
   "{1: 'a', True: 'b'}",
   "{True: 'b'}",
   "{1: 'b'}",
   "TypeError"
  ],
  "correctIndex": 2,
  "explanation": "1 == True and hash(1) == hash(True), so the same key is updated; the original key 1 is kept."
 },
 {
  "id": 52,
  "category": "py-ds",
  "q": "What is the output?\na = [[0]] * 3\na[0].append(1)\nprint(a)",
  "options": [
   "[[0, 1], [0], [0]]",
   "[[0], [0], [0]]",
   "[[0, 1], [0, 1], [0, 1]]",
   "[[1], [1], [1]]"
  ],
  "correctIndex": 2,
  "explanation": "List multiplication repeats references to the same inner list, not copies."
 },
 {
  "id": 53,
  "category": "py-ds",
  "q": "What is the output?\nprint(sorted(['bb', 'a', 'ccc'], key=len, reverse=True))",
  "options": [
   "['a', 'bb', 'ccc']",
   "['ccc', 'bb', 'a']",
   "['a', 'ccc', 'bb']",
   "['ccc', 'a', 'bb']"
  ],
  "correctIndex": 1,
  "explanation": "Sorting by length in descending order gives ccc, bb, a."
 },
 {
  "id": 54,
  "category": "py-ds",
  "q": "What is the output?\nl = [1, 2, 3, 4]\nl.pop(1)\nl.remove(3)\nprint(l)",
  "options": [
   "[1, 4]",
   "[1, 3]",
   "[2, 4]",
   "[1, 2, 4]"
  ],
  "correctIndex": 0,
  "explanation": "pop(1) removes the element at index 1 (the value 2); remove(3) then deletes the value 3, leaving [1, 4]."
 },
 {
  "id": 55,
  "category": "py-ds",
  "q": "What is the output?\nprint({**{'a': 1, 'b': 2}, **{'b': 3}})",
  "options": [
   "{'a': 1, 'b': 2}",
   "{'a': 1, 'b': 3}",
   "{'a': 1, 'b': 5}",
   "TypeError"
  ],
  "correctIndex": 1,
  "explanation": "In dict unpacking, later keys override earlier ones, so b becomes 3."
 },
 {
  "id": 56,
  "category": "py-ds",
  "q": "What is the output?\nl = [2, 4, 6, 8]\nfor x in l:\n    if x % 2 == 0:\n        l.remove(x)\nprint(l)",
  "options": [
   "[]",
   "[2, 4, 6, 8]",
   "[4, 8]",
   "[2, 6]"
  ],
  "correctIndex": 2,
  "explanation": "Removing while iterating shifts the indices, so every second element gets skipped."
 },
 {
  "id": 57,
  "category": "py-ds",
  "q": "What is the output?\nx = [3, 1, 2].sort()\nprint(x)",
  "options": [
   "[1, 2, 3]",
   "None",
   "[3, 1, 2]",
   "Error"
  ],
  "correctIndex": 1,
  "explanation": "list.sort() sorts in place and returns None; use sorted() to get a new list."
 },
 {
  "id": 58,
  "category": "py-ds",
  "q": "What is the output?\nprint(len({1, 1.0, True, '1'}))",
  "options": [
   "1",
   "2",
   "3",
   "4"
  ],
  "correctIndex": 1,
  "explanation": "1, 1.0 and True are equal and hash alike, so they collapse into one element; '1' is separate, giving 2."
 },
 {
  "id": 59,
  "category": "py-ds",
  "q": "What is the output?\nt = (1, 2, 3)\na, *b = t\nprint(b)",
  "options": [
   "(2, 3)",
   "2",
   "[2, 3]",
   "SyntaxError"
  ],
  "correctIndex": 2,
  "explanation": "Starred unpacking always collects the remaining items into a list, so b is [2, 3]."
 },
 {
  "id": 60,
  "category": "py-ds",
  "q": "What is the output?\nprint(len((1, 2) * 3))",
  "options": [
   "3",
   "5",
   "Error",
   "6"
  ],
  "correctIndex": 3,
  "explanation": "Tuple repetition creates (1, 2, 1, 2, 1, 2), which has 6 elements."
 },
 {
  "id": 61,
  "category": "py-ds",
  "q": "What happens?\nd = {'a': 1, 'b': 2}\nfor k in d:\n    d[k + 'x'] = 0",
  "options": [
   "d gets 4 keys",
   "Infinite loop",
   "RuntimeError: dictionary changed size during iteration",
   "KeyError"
  ],
  "correctIndex": 2,
  "explanation": "Adding keys to a dict while iterating over it raises RuntimeError."
 },
 {
  "id": 62,
  "category": "py-ds",
  "q": "What is the output?\nprint(len(set('hello')))",
  "options": [
   "5",
   "4",
   "3",
   "2"
  ],
  "correctIndex": 1,
  "explanation": "The unique characters are h, e, l, o, so the set has 4 elements."
 },
 {
  "id": 63,
  "category": "py-ds",
  "q": "What is the output?\na = [1, 2, 3]\na[1:2] = [7, 8, 9]\nprint(a)",
  "options": [
   "[1, [7, 8, 9], 3]",
   "[1, 7, 8, 9, 2, 3]",
   "[1, 7, 3]",
   "[1, 7, 8, 9, 3]"
  ],
  "correctIndex": 3,
  "explanation": "Slice assignment replaces the slice a[1:2] with the elements of the iterable, so the list grows."
 },
 {
  "id": 64,
  "category": "py-ds",
  "q": "What is the output?\nfrom collections import Counter\nprint(Counter('aabbbc').most_common(1))",
  "options": [
   "[('b', 3)]",
   "('b', 3)",
   "[('a', 2)]",
   "{'b': 3}"
  ],
  "correctIndex": 0,
  "explanation": "most_common(1) returns a list holding the single (element, count) pair with the highest count."
 },
 {
  "id": 65,
  "category": "py-ds",
  "q": "What is the output?\na = [1, 2]\nb = a\na += [3]\nprint(b)",
  "options": [
   "[1, 2]",
   "[3]",
   "Error",
   "[1, 2, 3]"
  ],
  "correctIndex": 3,
  "explanation": "+= on a list extends it in place, so b, which refers to the same object, also sees [1, 2, 3]."
 },
 {
  "id": 66,
  "category": "py-ds",
  "q": "What is the output?\nprint({k: v for k, v in zip('abc', [1, 2])})",
  "options": [
   "{'a': 1, 'b': 2}",
   "{'a': 1, 'b': 2, 'c': None}",
   "ValueError",
   "{'a': 1, 'b': 2, 'c': 0}"
  ],
  "correctIndex": 0,
  "explanation": "zip stops at the shortest iterable, so 'c' is dropped."
 },
 {
  "id": 67,
  "category": "py-ds",
  "q": "What is the output?\nd = dict.fromkeys(['a', 'b'], [])\nd['a'].append(1)\nprint(d)",
  "options": [
   "{'a': [1], 'b': []}",
   "{'a': [1], 'b': [1]}",
   "{'a': 1, 'b': None}",
   "KeyError"
  ],
  "correctIndex": 1,
  "explanation": "fromkeys uses the same list object as the value for every key, so both keys show the append."
 },
 {
  "id": 68,
  "category": "py-ds",
  "q": "What is the output?\nprint(sorted([(1,'b'), (1,'a'), (0,'z')], key=lambda x: x[0]))",
  "options": [
   "[(0, 'z'), (1, 'a'), (1, 'b')]",
   "[(1, 'a'), (1, 'b'), (0, 'z')]",
   "[(0, 'z'), (1, 'b'), (1, 'a')]",
   "[(1, 'b'), (1, 'a'), (0, 'z')]"
  ],
  "correctIndex": 2,
  "explanation": "sorted is stable, so items with equal keys keep their original order: (1,'b') stays before (1,'a')."
 },
 {
  "id": 69,
  "category": "py-ds",
  "q": "What is printed?\n\nd = dict.fromkeys(['a', 'b'], [])\nd['a'].append(1)\nprint(d['b'])",
  "options": [
   "[]",
   "[1]",
   "None",
   "KeyError"
  ],
  "correctIndex": 1,
  "explanation": "dict.fromkeys uses the same single list object as the value for every key, so appending via 'a' is also visible via 'b'."
 },
 {
  "id": 70,
  "category": "py-ds",
  "q": "What is printed?\n\nd = {'a': 1, 'b': 2}\ndel d['a']\nd['a'] = 3\nprint(list(d))",
  "options": [
   "['a', 'b']",
   "['b', 'a']",
   "['a']",
   "['b']"
  ],
  "correctIndex": 1,
  "explanation": "Dicts keep insertion order; deleting 'a' and re-adding it places it after 'b', giving ['b', 'a']."
 },
 {
  "id": 71,
  "category": "py-oop",
  "q": "Which special method is called automatically right after a new instance is created, to initialize its attributes?",
  "options": [
   "__new__",
   "__init__",
   "__call__",
   "__enter__"
  ],
  "correctIndex": 1,
  "explanation": "__new__ creates the object, then __init__ initializes it."
 },
 {
  "id": 72,
  "category": "py-oop",
  "q": "Output?\nclass A:\n    x = 1\na = A()\nb = A()\na.x = 5\nprint(b.x, A.x)",
  "options": [
   "1 1",
   "5 1",
   "5 5",
   "1 5"
  ],
  "correctIndex": 0,
  "explanation": "a.x = 5 creates an instance attribute on a only; the class attribute and b still see 1."
 },
 {
  "id": 73,
  "category": "py-oop",
  "q": "Output?\nclass A:\n    items = []\n    def add(self, v):\n        self.items.append(v)\na = A(); b = A()\na.add(1)\nprint(b.items)",
  "options": [
   "[]",
   "[1]",
   "AttributeError",
   "None"
  ],
  "correctIndex": 1,
  "explanation": "items is a shared class-level list; append mutates it, so b sees the change."
 },
 {
  "id": 74,
  "category": "py-oop",
  "q": "Output?\nclass A:\n    def f(self): return 'A'\nclass B(A):\n    def f(self): return 'B'\nclass C(A):\n    def f(self): return 'C'\nclass D(B, C): pass\nprint(D().f())",
  "options": [
   "A",
   "C",
   "B",
   "TypeError"
  ],
  "correctIndex": 2,
  "explanation": "The MRO of D is D, B, C, A, so B.f is found first."
 },
 {
  "id": 75,
  "category": "py-oop",
  "q": "Output?\nclass A:\n    def __init__(self): print('A')\nclass B(A):\n    def __init__(self):\n        print('B')\n        super().__init__()\nB()",
  "options": [
   "A only",
   "B only",
   "A, then B",
   "B, then A"
  ],
  "correctIndex": 3,
  "explanation": "B prints 'B' first, then super().__init__() runs A's initializer and prints 'A'."
 },
 {
  "id": 76,
  "category": "py-oop",
  "q": "Inside class Account, an attribute is set as self.__balance. How is it stored due to name mangling?",
  "options": [
   "_Account__balance",
   "__Account_balance",
   "Account.__balance",
   "It becomes truly inaccessible"
  ],
  "correctIndex": 0,
  "explanation": "Python rewrites __name inside class C to _C__name; it is obscured, not truly private."
 },
 {
  "id": 77,
  "category": "py-oop",
  "q": "Which decorator makes a method receive the class itself (cls) as its first argument?",
  "options": [
   "@staticmethod",
   "@property",
   "@classmethod",
   "@abstractmethod"
  ],
  "correctIndex": 2,
  "explanation": "@classmethod passes cls, which is useful for alternative constructors."
 },
 {
  "id": 78,
  "category": "py-oop",
  "q": "A class defines a read-only @property named 'area' with no setter. What does obj.area = 10 do?",
  "options": [
   "Silently ignored",
   "Raises AttributeError",
   "Creates an instance attribute",
   "Raises TypeError"
  ],
  "correctIndex": 1,
  "explanation": "Assigning to a property without a setter raises AttributeError (can't set attribute)."
 },
 {
  "id": 79,
  "category": "py-oop",
  "q": "A class defines only __repr__ (not __str__). What does print(obj) display?",
  "options": [
   "The default <object at 0x...> text",
   "An empty string",
   "A TypeError is raised",
   "The string returned by __repr__"
  ],
  "correctIndex": 3,
  "explanation": "object.__str__ falls back to __repr__ when __str__ is not defined."
 },
 {
  "id": 80,
  "category": "py-oop",
  "q": "What happens when you instantiate a subclass of abc.ABC that has not implemented an @abstractmethod?",
  "options": [
   "TypeError",
   "NotImplementedError at call time",
   "The method returns None",
   "AttributeError"
  ],
  "correctIndex": 0,
  "explanation": "ABCs prevent instantiation while abstract methods remain, raising TypeError."
 },
 {
  "id": 81,
  "category": "py-oop",
  "q": "A class defines __eq__ but not __hash__. What happens on hash(obj) in Python 3?",
  "options": [
   "Uses id() based hash",
   "Raises TypeError: unhashable type",
   "Returns 0",
   "Returns hash of __eq__ result"
  ],
  "correctIndex": 2,
  "explanation": "Defining __eq__ sets __hash__ to None unless it is defined explicitly, making instances unhashable."
 },
 {
  "id": 82,
  "category": "py-oop",
  "q": "Output?\nprint(issubclass(bool, int), isinstance(True, int))",
  "options": [
   "False True",
   "True True",
   "True False",
   "False False"
  ],
  "correctIndex": 1,
  "explanation": "bool is a subclass of int, so True is an instance of int."
 },
 {
  "id": 83,
  "category": "py-oop",
  "q": "Output?\nclass P:\n    def show(self): return 'P'\n    def call(self): return self.show()\nclass C(P):\n    def show(self): return 'C'\nprint(C().call())",
  "options": [
   "P",
   "Error",
   "PC",
   "C"
  ],
  "correctIndex": 3,
  "explanation": "self.show() is resolved dynamically on the actual object's class, so the override C.show runs."
 },
 {
  "id": 84,
  "category": "py-oop",
  "q": "Class has __slots__ = ('a',). What does obj.b = 1 do on an instance?",
  "options": [
   "Raises AttributeError",
   "Creates b normally",
   "Raises KeyError",
   "Adds b to __slots__"
  ],
  "correctIndex": 0,
  "explanation": "__slots__ removes __dict__, so attributes not listed cannot be added."
 },
 {
  "id": 85,
  "category": "py-oop",
  "q": "Output?\nclass A:\n    def __init__(self, l=[]):\n        self.l = l\na = A(); b = A()\na.l.append(1)\nprint(b.l)",
  "options": [
   "[]",
   "None",
   "[1]",
   "Error"
  ],
  "correctIndex": 2,
  "explanation": "The default list is created once at definition time and shared by all instances."
 },
 {
  "id": 86,
  "category": "py-oop",
  "q": "What must a class define so that its instances can be called like functions, e.g. obj(5)?",
  "options": [
   "__invoke__",
   "__call__",
   "__run__",
   "__exec__"
  ],
  "correctIndex": 1,
  "explanation": "__call__ makes instances callable."
 },
 {
  "id": 87,
  "category": "py-oop",
  "q": "What does the @dataclass decorator automatically generate by default?",
  "options": [
   "Only __init__",
   "Only __str__ and __len__",
   "Getters and setters for every field",
   "__init__, __repr__ and __eq__"
  ],
  "correctIndex": 3,
  "explanation": "dataclass auto-generates __init__, __repr__ and __eq__ from annotated fields."
 },
 {
  "id": 88,
  "category": "py-oop",
  "q": "Output of D().go()?\nclass A:\n    def go(self): print('A')\nclass B(A):\n    def go(self): print('B'); super().go()\nclass C(A):\n    def go(self): print('C'); super().go()\nclass D(B, C):\n    def go(self): print('D'); super().go()",
  "options": [
   "D B C A",
   "D B A",
   "D B A C",
   "D A"
  ],
  "correctIndex": 0,
  "explanation": "super() follows the MRO D, B, C, A, so B's super call reaches C before A."
 },
 {
  "id": 89,
  "category": "py-oop",
  "q": "Which method is best suited to control instance creation, e.g. implementing a Singleton?",
  "options": [
   "__init__",
   "__del__",
   "__new__",
   "__repr__"
  ],
  "correctIndex": 2,
  "explanation": "__new__ allocates and returns the instance, so it can return an existing one."
 },
 {
  "id": 90,
  "category": "py-oop",
  "q": "When is __getattr__ invoked on an object?",
  "options": [
   "On every attribute access",
   "Only when normal attribute lookup fails",
   "Only when setting attributes",
   "Only for private attributes"
  ],
  "correctIndex": 1,
  "explanation": "__getattr__ is a fallback after normal lookup raises AttributeError; __getattribute__ handles every access."
 },
 {
  "id": 91,
  "category": "py-oop",
  "q": "Which special method must a class define so that the built-in len(obj) works on its instances?",
  "options": [
   "__size__",
   "__len__",
   "__count__",
   "__length__"
  ],
  "correctIndex": 1,
  "explanation": "len(obj) calls type(obj).__len__(obj), which must return a non-negative integer."
 },
 {
  "id": 92,
  "category": "py-oop",
  "q": "Output?\nclass A:\n    @staticmethod\n    def f(x): return x*2\nprint(A.f(3), A().f(4))",
  "options": [
   "6 and TypeError",
   "TypeError",
   "6 8",
   "3 4"
  ],
  "correctIndex": 2,
  "explanation": "A staticmethod receives no implicit first argument, so it can be called on the class or on an instance."
 },
 {
  "id": 93,
  "category": "py-oop",
  "q": "Output?\nclass A:\n    def __str__(self): return 'S'\n    def __repr__(self): return 'R'\nprint([A()], str(A()))",
  "options": [
   "[R] S",
   "[S] S",
   "[R] R",
   "[S] R"
  ],
  "correctIndex": 0,
  "explanation": "Containers display their elements with repr(), giving [R], while str() calls __str__, giving S."
 },
 {
  "id": 94,
  "category": "py-oop",
  "q": "Output?\nclass A:\n    n = 0\n    def inc(self): self.n += 1\na = A(); a.inc(); a.inc()\nprint(A.n, a.n)",
  "options": [
   "2 2",
   "2 0",
   "1 1",
   "0 2"
  ],
  "correctIndex": 3,
  "explanation": "self.n += 1 reads the class attribute but rebinds n on the instance, so A.n stays 0 and a.n becomes 2."
 },
 {
  "id": 95,
  "category": "py-oop",
  "q": "Output?\nclass V:\n    def __init__(self, x): self.x = x\n    def __add__(self, o): return V(self.x + o.x)\nprint(sum([V(1), V(2)]).x)",
  "options": [
   "3",
   "0",
   "TypeError",
   "AttributeError: x"
  ],
  "correctIndex": 2,
  "explanation": "sum() starts with 0, so it evaluates 0 + V(1). int cannot add a V and V has no __radd__, so it raises TypeError."
 },
 {
  "id": 96,
  "category": "py-func",
  "q": "What is the output?\ndef f(a, b=[]):\n    b.append(a)\n    return b\nprint(f(1), f(2))",
  "options": [
   "[1] [2]",
   "[1, 2] [1, 2]",
   "[1] [1, 2]",
   "[2] [2]"
  ],
  "correctIndex": 1,
  "explanation": "The default list is created once and shared; both calls return the same list, which holds [1, 2] when printed."
 },
 {
  "id": 97,
  "category": "py-func",
  "q": "def g():\n    yield 1\n    yield 2\nx = g()\nnext(x); next(x)\nWhat happens on a third call to next(x)?",
  "options": [
   "Returns None",
   "Returns 2 again",
   "Raises StopIteration",
   "Restarts and returns 1"
  ],
  "correctIndex": 2,
  "explanation": "An exhausted generator raises StopIteration on further next() calls."
 },
 {
  "id": 98,
  "category": "py-func",
  "q": "With @A above @B above def f(), which decorator is applied to f first?",
  "options": [
   "B first, then A wraps the result",
   "A first, then B wraps the result",
   "Both are applied in parallel",
   "Order depends on the function name"
  ],
  "correctIndex": 0,
  "explanation": "Stacked decorators are applied bottom-up, so f = A(B(f))."
 },
 {
  "id": 99,
  "category": "py-func",
  "q": "What is the main purpose of functools.wraps in a decorator's wrapper function?",
  "options": [
   "Makes the wrapper run faster",
   "Allows the wrapper to accept *args",
   "Caches the wrapped function's results",
   "Preserves the original function's __name__ and __doc__"
  ],
  "correctIndex": 3,
  "explanation": "wraps copies metadata such as __name__, __doc__ and __wrapped__ from the original to the wrapper."
 },
 {
  "id": 100,
  "category": "py-func",
  "q": "def f(*args):\n    print(type(args))\nf(1, 2, 3)\nWhat is printed?",
  "options": [
   "<class 'list'>",
   "<class 'dict'>",
   "<class 'tuple'>",
   "<class 'set'>"
  ],
  "correctIndex": 2,
  "explanation": "*args collects extra positional arguments into a tuple."
 },
 {
  "id": 101,
  "category": "py-func",
  "q": "What does this return?\ndef outer():\n    x = 1\n    def inner():\n        nonlocal x\n        x += 1\n    inner()\n    return x\nprint(outer())",
  "options": [
   "2",
   "1",
   "UnboundLocalError",
   "SyntaxError"
  ],
  "correctIndex": 0,
  "explanation": "nonlocal lets inner rebind outer's x, so x becomes 2."
 },
 {
  "id": 102,
  "category": "py-func",
  "q": "Which expression produces values lazily and uses O(1) memory for 10**6 squares?",
  "options": [
   "[x*x for x in range(10**6)]",
   "tuple(x*x for x in range(10**6))",
   "list(map(lambda x: x*x, range(10**6)))",
   "(x*x for x in range(10**6))"
  ],
  "correctIndex": 3,
  "explanation": "A generator expression yields one item at a time; the others materialize all values in memory."
 },
 {
  "id": 103,
  "category": "py-func",
  "q": "What is the output?\ndef g():\n    yield from [1, 2]\n    yield 3\nprint(list(g()))",
  "options": [
   "[[1, 2], 3]",
   "[1, 2, 3]",
   "[3]",
   "[1, 2]"
  ],
  "correctIndex": 1,
  "explanation": "yield from delegates to the iterable, yielding 1 and 2, then the generator yields 3."
 },
 {
  "id": 104,
  "category": "py-func",
  "q": "What is printed?\ndef g():\n    x = yield 1\n    print(x)\n    yield 2\ng1 = g()\nnext(g1)\nprint(g1.send('hi'))",
  "options": [
   "None, then 2",
   "hi only",
   "hi, then 2",
   "1, then hi"
  ],
  "correctIndex": 2,
  "explanation": "send('hi') makes the paused yield evaluate to 'hi'; it is printed, then the generator yields 2 which is printed."
 },
 {
  "id": 105,
  "category": "py-func",
  "q": "def f(a, *, b):\n    return a + b\nWhich call raises a TypeError?",
  "options": [
   "f(1, 2)",
   "f(1, b=2)",
   "f(a=1, b=2)",
   "f(b=2, a=1)"
  ],
  "correctIndex": 0,
  "explanation": "Parameters after * are keyword-only, so b cannot be passed positionally."
 },
 {
  "id": 106,
  "category": "py-func",
  "q": "What does this print?\nprint((lambda x, y=2: x * y)(3))",
  "options": [
   "5",
   "3",
   "TypeError",
   "6"
  ],
  "correctIndex": 3,
  "explanation": "y defaults to 2, so the lambda returns 3*2 = 6."
 },
 {
  "id": 107,
  "category": "py-func",
  "q": "A decorator that takes its own arguments, like @retry(3), is typically implemented with how many nested layers?",
  "options": [
   "One: just the wrapper",
   "Three: factory, decorator, wrapper",
   "Two: decorator and wrapper only",
   "Four: class, factory, decorator, wrapper"
  ],
  "correctIndex": 1,
  "explanation": "retry(3) returns a decorator, which takes the function and returns a wrapper."
 },
 {
  "id": 108,
  "category": "py-func",
  "q": "What happens?\nx = 10\ndef f():\n    print(x)\n    x = 5\nf()",
  "options": [
   "Prints 10",
   "Prints 5",
   "UnboundLocalError",
   "NameError"
  ],
  "correctIndex": 2,
  "explanation": "Assignment makes x local throughout f, so reading it before assignment raises UnboundLocalError."
 },
 {
  "id": 109,
  "category": "py-func",
  "q": "What is printed?\ndef f():\n    pass\nprint(f())",
  "options": [
   "None",
   "pass",
   "An empty string",
   "Nothing; it raises an error"
  ],
  "correctIndex": 0,
  "explanation": "A function without a return statement implicitly returns None."
 },
 {
  "id": 110,
  "category": "py-func",
  "q": "Which methods must an object implement to be an iterator in Python 3?",
  "options": [
   "__len__ and __getitem__",
   "__call__ and __iter__",
   "__next__ only",
   "__iter__ and __next__"
  ],
  "correctIndex": 3,
  "explanation": "The iterator protocol requires __iter__ (returning self) and __next__."
 },
 {
  "id": 111,
  "category": "py-func",
  "q": "What is the output?\ng = (x for x in range(3))\nprint(list(g), list(g))",
  "options": [
   "[0, 1, 2] [0, 1, 2]",
   "[0, 1, 2] []",
   "[] []",
   "[0, 1, 2] [0]"
  ],
  "correctIndex": 1,
  "explanation": "A generator can be consumed only once; the second list() gets nothing."
 },
 {
  "id": 112,
  "category": "py-func",
  "q": "from functools import lru_cache\n@lru_cache\ndef f(l):\n    return sum(l)\nf([1, 2])\nWhat happens?",
  "options": [
   "Returns 3 and caches it",
   "Returns 3 without caching",
   "TypeError: unhashable type: 'list'",
   "RecursionError"
  ],
  "correctIndex": 2,
  "explanation": "lru_cache uses arguments as dict keys, so they must be hashable; lists are not."
 },
 {
  "id": 113,
  "category": "py-func",
  "q": "What is the output?\ndef d(f):\n    print('decorating')\n    return f\n@d\ndef h():\n    print('run')\nprint('end')",
  "options": [
   "decorating\nend",
   "end",
   "decorating\nrun\nend",
   "run\nend"
  ],
  "correctIndex": 0,
  "explanation": "The decorator runs at definition time; h is never called, so 'run' is never printed."
 },
 {
  "id": 114,
  "category": "py-func",
  "q": "What does this return?\ndef f(a, b, c):\n    return a + b + c\nprint(f(*[1, 2], **{'c': 3}))",
  "options": [
   "TypeError",
   "(1, 2, 3)",
   "123",
   "6"
  ],
  "correctIndex": 3,
  "explanation": "The list unpacks to a=1, b=2 and the dict supplies c=3, giving 6."
 },
 {
  "id": 115,
  "category": "py-func",
  "q": "What is the output?\ndef f(x, y):\n    return x - y\nprint(f(y=1, x=5))",
  "options": [
   "-4",
   "Raises TypeError",
   "4",
   "Raises SyntaxError"
  ],
  "correctIndex": 2,
  "explanation": "Keyword arguments are matched by name, not position, so x=5 and y=1 give 5 - 1 = 4."
 },
 {
  "id": 116,
  "category": "py-func",
  "q": "What is the output?\ndef g():\n    return 1\n    yield 2\nprint(type(g()))",
  "options": [
   "<class 'int'>",
   "<class 'generator'>",
   "<class 'NoneType'>",
   "<class 'function'>"
  ],
  "correctIndex": 1,
  "explanation": "Any yield in the body makes g a generator function, so calling it returns a generator object without running the body."
 },
 {
  "id": 117,
  "category": "py-func",
  "q": "What is printed?\ndef count(f):\n    def w(*a, **k):\n        w.calls += 1\n        return f(*a, **k)\n    w.calls = 0\n    return w\n@count\ndef hi(): pass\nhi(); hi()\nprint(hi.calls)",
  "options": [
   "0",
   "1",
   "AttributeError",
   "2"
  ],
  "correctIndex": 3,
  "explanation": "hi is replaced by w, a function object with a calls attribute that is incremented on each call, so it is 2."
 },
 {
  "id": 118,
  "category": "py-func",
  "q": "What is printed?\ndef g():\n    yield 1\n    return 5\nit = g()\nnext(it)\ntry:\n    next(it)\nexcept StopIteration as e:\n    print(e.value)",
  "options": [
   "5",
   "None",
   "1",
   "RuntimeError is raised"
  ],
  "correctIndex": 0,
  "explanation": "A return value inside a generator is carried in the StopIteration exception's value attribute."
 },
 {
  "id": 119,
  "category": "py-func",
  "q": "What is the output?\nprint(list(map(lambda x: x*2, filter(lambda x: x % 2, range(5)))))",
  "options": [
   "[0, 4, 8]",
   "[2, 6]",
   "[1, 3]",
   "[0, 2, 4, 6, 8]"
  ],
  "correctIndex": 2,
  "explanation": "filter keeps the odd numbers 1 and 3, then map doubles them, giving [2, 6]."
 },
 {
  "id": 120,
  "category": "py-func",
  "q": "What does this code print?\n\nfuncs = [lambda: i for i in range(3)]\nprint([f() for f in funcs])",
  "options": [
   "[0, 1, 2]",
   "[2, 2, 2]",
   "[3, 3, 3]",
   "It raises NameError because i is not defined when the lambdas are called"
  ],
  "correctIndex": 1,
  "explanation": "Closures capture the variable i, not its value at creation time (late binding); after the comprehension finishes, i is 2, so every lambda returns 2."
 },
 {
  "id": 121,
  "category": "py-exc",
  "q": "In Python exception handling, which block runs regardless of whether an exception was raised or handled?",
  "options": [
   "else",
   "finally",
   "except",
   "try"
  ],
  "correctIndex": 1,
  "explanation": "The finally block always executes, which makes it the right place for cleanup code."
 },
 {
  "id": 122,
  "category": "py-exc",
  "q": "What is the output?\ntry:\n    print(1/0)\nexcept ZeroDivisionError:\n    print('A')\nelse:\n    print('B')\nfinally:\n    print('C')",
  "options": [
   "A B C",
   "B C",
   "A C",
   "C"
  ],
  "correctIndex": 2,
  "explanation": "The exception prints A, else is skipped because an exception occurred, and finally prints C."
 },
 {
  "id": 123,
  "category": "py-exc",
  "q": "What does this print?\ndef f():\n    try:\n        return 1\n    finally:\n        return 2\nprint(f())",
  "options": [
   "1",
   "2",
   "None",
   "It raises SyntaxError"
  ],
  "correctIndex": 1,
  "explanation": "A return inside finally overrides the earlier return value, so the function returns 2."
 },
 {
  "id": 124,
  "category": "py-exc",
  "q": "Which file mode creates a new file and raises FileExistsError if the file already exists?",
  "options": [
   "'w'",
   "'a'",
   "'r+'",
   "'x'"
  ],
  "correctIndex": 3,
  "explanation": "Exclusive creation mode 'x' fails with FileExistsError if the target already exists."
 },
 {
  "id": 125,
  "category": "py-exc",
  "q": "What is printed?\ntry:\n    int('abc')\nexcept (TypeError, ValueError) as e:\n    print(type(e).__name__)",
  "options": [
   "TypeError",
   "ValueError",
   "Exception",
   "Nothing is printed"
  ],
  "correctIndex": 1,
  "explanation": "int('abc') raises ValueError, which matches the tuple of exception types."
 },
 {
  "id": 126,
  "category": "py-exc",
  "q": "Why is `with open('f.txt') as f:` preferred over calling open() and close() manually?",
  "options": [
   "It makes file reads faster",
   "It opens the file in binary mode",
   "It closes the file automatically, even if an exception occurs",
   "It stops FileNotFoundError from being raised"
  ],
  "correctIndex": 2,
  "explanation": "The context manager guarantees f.close() is called on exit, including when an exception is raised."
 },
 {
  "id": 127,
  "category": "py-exc",
  "q": "What is the output?\ntry:\n    x = [1][5]\nexcept LookupError:\n    print('L')\nexcept IndexError:\n    print('I')",
  "options": [
   "L",
   "I",
   "L I",
   "IndexError is raised"
  ],
  "correctIndex": 0,
  "explanation": "IndexError is a subclass of LookupError, and the first matching except clause handles it, so only L prints."
 },
 {
  "id": 128,
  "category": "py-exc",
  "q": "What does a bare `raise` statement do inside an except block?",
  "options": [
   "Raises a generic Exception",
   "Re-raises the exception currently being handled",
   "Clears the current exception",
   "Raises a RuntimeError"
  ],
  "correctIndex": 1,
  "explanation": "A bare raise re-raises the active exception with its original traceback."
 },
 {
  "id": 129,
  "category": "py-exc",
  "q": "A text file is opened in 'r' mode and all its content has already been read. What does f.read() return now?",
  "options": [
   "None",
   "An EOFError is raised",
   "An empty string ''",
   "The whole content again"
  ],
  "correctIndex": 2,
  "explanation": "At end of file, read() returns an empty string and does not raise an error."
 },
 {
  "id": 130,
  "category": "py-exc",
  "q": "What does `raise AppError('fail') from e` do?",
  "options": [
   "Suppresses the original exception completely",
   "Sets e as the __cause__ of the new exception, explicitly chaining them",
   "Raises both exceptions at the same time",
   "Converts e into a warning"
  ],
  "correctIndex": 1,
  "explanation": "The 'from' clause stores e in __cause__, and the traceback shows it as the direct cause."
 },
 {
  "id": 131,
  "category": "py-exc",
  "q": "What is printed?\nclass MyErr(Exception):\n    pass\ntry:\n    raise MyErr('bad')\nexcept MyErr as e:\n    print(e)",
  "options": [
   "MyErr",
   "bad",
   "MyErr('bad')",
   "Nothing is printed"
  ],
  "correctIndex": 1,
  "explanation": "str(e) of an exception returns its message argument, which is 'bad'."
 },
 {
  "id": 132,
  "category": "py-exc",
  "q": "What happens?\ntry:\n    1/0\nexcept ZeroDivisionError as e:\n    pass\nprint(e)",
  "options": [
   "Prints the ZeroDivisionError message",
   "Prints None",
   "Raises NameError",
   "Raises ZeroDivisionError"
  ],
  "correctIndex": 2,
  "explanation": "Python deletes the 'as e' name when the except block ends, so print(e) raises NameError."
 },
 {
  "id": 133,
  "category": "py-exc",
  "q": "What is the output?\nwith open('a.txt','w+') as f:\n    f.write('hello')\n    f.seek(0)\n    print(f.read(2))",
  "options": [
   "hello",
   "he",
   "llo",
   "An empty string"
  ],
  "correctIndex": 1,
  "explanation": "seek(0) moves back to the start, and read(2) returns the first two characters, 'he'."
 },
 {
  "id": 134,
  "category": "py-exc",
  "q": "What is the output?\nfor i in range(3):\n    try:\n        if i == 1:\n            continue\n        print(i)\n    finally:\n        print('f')",
  "options": [
   "0 f 2 f",
   "0 f f 2 f",
   "0 f 1 f 2 f",
   "0 2 f"
  ],
  "correctIndex": 1,
  "explanation": "finally runs on every iteration, including the i==1 iteration that exits via continue, so the output is 0 f f 2 f."
 },
 {
  "id": 135,
  "category": "py-exc",
  "q": "A file has the text 'AB'. You open it with mode 'a', write 'C', and close it. What does reading it back return?",
  "options": [
   "'C'",
   "'ABC'",
   "'CAB'",
   "'AB'"
  ],
  "correctIndex": 1,
  "explanation": "Append mode keeps the existing content and writes new data at the end, giving 'ABC'."
 },
 {
  "id": 136,
  "category": "py-stdlib",
  "q": "Which standard library module provides the Counter class for counting hashable items?",
  "options": [
   "itertools",
   "functools",
   "collections",
   "operator"
  ],
  "correctIndex": 2,
  "explanation": "Counter, deque, defaultdict, OrderedDict and namedtuple all live in the collections module."
 },
 {
  "id": 137,
  "category": "py-stdlib",
  "q": "What is the output?\nfrom collections import Counter\nc = Counter('banana')\nprint(c.most_common(1))",
  "options": [
   "[('a', 3)]",
   "[('n', 2)]",
   "('a', 3)",
   "[('b', 1)]"
  ],
  "correctIndex": 0,
  "explanation": "'a' appears 3 times, and most_common(1) returns a list holding one (element, count) tuple."
 },
 {
  "id": 138,
  "category": "py-stdlib",
  "q": "What is the output?\nimport math\nprint(math.floor(-2.5), math.ceil(-2.5))",
  "options": [
   "-2 -3",
   "-3 -2",
   "-3 -3",
   "-2 -2"
  ],
  "correctIndex": 1,
  "explanation": "floor rounds toward negative infinity (-3) and ceil toward positive infinity (-2)."
 },
 {
  "id": 139,
  "category": "py-stdlib",
  "q": "What is the purpose of the check if __name__ == '__main__': in a Python file?",
  "options": [
   "It imports the main module automatically",
   "It declares the entry function required by Python",
   "It prevents the module from being imported",
   "It runs the block only when the file is executed directly, not imported"
  ],
  "correctIndex": 3,
  "explanation": "__name__ equals '__main__' only for the script being run; on import it is the module name."
 },
 {
  "id": 140,
  "category": "py-stdlib",
  "q": "What is the output?\nimport itertools\nprint(list(itertools.islice(itertools.count(5, 2), 3)))",
  "options": [
   "[5, 7]",
   "[7, 9, 11]",
   "[5, 7, 9]",
   "[5, 6, 7]"
  ],
  "correctIndex": 2,
  "explanation": "count(5, 2) yields 5, 7, 9, ... and islice takes the first 3 values."
 },
 {
  "id": 141,
  "category": "py-stdlib",
  "q": "What does the functools.lru_cache decorator primarily provide?",
  "options": [
   "Thread-safe locking of a function",
   "Memoization of function results for repeated arguments",
   "Lazy evaluation of generators",
   "Automatic type checking of arguments"
  ],
  "correctIndex": 1,
  "explanation": "lru_cache stores results keyed by arguments, which speeds up recursive functions like Fibonacci."
 },
 {
  "id": 142,
  "category": "py-stdlib",
  "q": "What is the output?\nfrom datetime import date\nprint((date(2024,3,1) - date(2024,2,1)).days)",
  "options": [
   "29",
   "28",
   "30",
   "31"
  ],
  "correctIndex": 0,
  "explanation": "2024 is a leap year, so February has 29 days and the difference is 29."
 },
 {
  "id": 143,
  "category": "py-stdlib",
  "q": "What is the output?\nimport json\nprint(json.dumps({'a': None, 'b': True}))",
  "options": [
   "{\"a\": None, \"b\": True}",
   "{\"a\": \"None\", \"b\": \"True\"}",
   "{'a': null, 'b': true}",
   "{\"a\": null, \"b\": true}"
  ],
  "correctIndex": 3,
  "explanation": "JSON uses null/true/false, and json.dumps emits double-quoted keys."
 },
 {
  "id": 144,
  "category": "py-stdlib",
  "q": "What is the output?\nfrom collections import deque\nd = deque([1, 2, 3])\nd.rotate(1)\nprint(list(d))",
  "options": [
   "[2, 3, 1]",
   "[3, 1, 2]",
   "[1, 3, 2]",
   "[3, 2, 1]"
  ],
  "correctIndex": 1,
  "explanation": "rotate(1) shifts elements one step to the right, so the last element moves to the front."
 },
 {
  "id": 145,
  "category": "py-stdlib",
  "q": "What does os.path.join('a', '/b', 'c') return on Linux?",
  "options": [
   "a/b/c",
   "a//b/c",
   "/b/c",
   "/a/b/c"
  ],
  "correctIndex": 2,
  "explanation": "An absolute component discards all earlier parts, so the result is '/b/c'."
 },
 {
  "id": 146,
  "category": "py-stdlib",
  "q": "In a script run as `python app.py x y`, what does sys.argv[0] contain?",
  "options": [
   "app.py (the script name)",
   "x",
   "The Python interpreter path",
   "An empty string"
  ],
  "correctIndex": 0,
  "explanation": "sys.argv[0] is the script name and the arguments x and y follow at indices 1 and 2."
 },
 {
  "id": 147,
  "category": "py-stdlib",
  "q": "What is the output?\nfrom collections import defaultdict\nd = defaultdict(list)\nd['x'].append(1)\nprint(len(d), d['y'])",
  "options": [
   "1 KeyError",
   "2 []",
   "2 None",
   "1 []"
  ],
  "correctIndex": 3,
  "explanation": "len(d) is evaluated first and gives 1; then d['y'] creates and returns an empty list."
 },
 {
  "id": 148,
  "category": "py-stdlib",
  "q": "What is the output?\nimport heapq\nprint(heapq.nlargest(2, [4, 9, 1, 7]))",
  "options": [
   "[1, 4]",
   "[9, 7]",
   "[7, 9]",
   "[9, 4]"
  ],
  "correctIndex": 1,
  "explanation": "nlargest returns the n biggest items in descending order: [9, 7]."
 },
 {
  "id": 149,
  "category": "py-stdlib",
  "q": "What is the output?\nimport itertools\nprint(len(list(itertools.combinations(range(5), 3))))",
  "options": [
   "10",
   "60",
   "15",
   "125"
  ],
  "correctIndex": 0,
  "explanation": "C(5,3) = 10 combinations, because order does not matter."
 },
 {
  "id": 150,
  "category": "py-stdlib",
  "q": "If a module is imported twice in the same program, what happens the second time?",
  "options": [
   "It is re-executed from the top",
   "It raises ImportError",
   "The cached module in sys.modules is reused without re-running it",
   "It is reloaded only if the file has changed"
  ],
  "correctIndex": 2,
  "explanation": "Python caches loaded modules in sys.modules, and importlib.reload is needed to re-execute one."
 },
 {
  "id": 151,
  "category": "py-conc",
  "q": "What does the CPython Global Interpreter Lock (GIL) ensure?",
  "options": [
   "Every Python thread runs on its own CPU core in parallel",
   "Only one thread executes Python bytecode at a time in a process",
   "Each thread gets its own private copy of all objects",
   "All compound operations like n += 1 are atomic"
  ],
  "correctIndex": 1,
  "explanation": "The GIL is a mutex that lets only one thread run Python bytecode at a time per interpreter; it does not make compound operations atomic."
 },
 {
  "id": 152,
  "category": "py-conc",
  "q": "Which workload benefits MOST from using threading in standard CPython?",
  "options": [
   "Many concurrent HTTP calls waiting on network responses",
   "Pure-Python matrix multiplication with nested loops",
   "Computing SHA-256 of in-memory strings in a Python loop",
   "Recursive Fibonacci of large numbers"
  ],
  "correctIndex": 0,
  "explanation": "Threads release the GIL while blocked on I/O, so I/O-bound tasks overlap; CPU-bound pure-Python code does not."
 },
 {
  "id": 153,
  "category": "py-conc",
  "q": "To achieve true CPU parallelism for pure-Python number crunching in standard CPython, which is the best choice?",
  "options": [
   "threading.Thread with more threads",
   "asyncio with many tasks",
   "multiprocessing or ProcessPoolExecutor",
   "Adding time.sleep(0) calls in loops"
  ],
  "correctIndex": 2,
  "explanation": "Separate processes each have their own interpreter and GIL, so they can use multiple cores in parallel."
 },
 {
  "id": 154,
  "category": "py-conc",
  "q": "Output?\nimport threading\nn=0\ndef f():\n    global n\n    for _ in range(100000): n+=1\nts=[threading.Thread(target=f) for _ in range(2)]\nfor t in ts: t.start()\nfor t in ts: t.join()\nprint(n)",
  "options": [
   "Always exactly 200000 because of the GIL",
   "Always exactly 100000",
   "Raises RuntimeError due to the race",
   "Not guaranteed; may be less than 200000"
  ],
  "correctIndex": 3,
  "explanation": "n += 1 is load, add, store; threads can be switched in between, so updates can be lost. Use a Lock."
 },
 {
  "id": 155,
  "category": "py-conc",
  "q": "What does t.join() do when called on a threading.Thread object t from the main thread?",
  "options": [
   "Starts the thread t",
   "Blocks the caller until thread t finishes (or the timeout expires)",
   "Kills thread t immediately",
   "Merges t's variables into the main thread"
  ],
  "correctIndex": 1,
  "explanation": "join() waits for the target thread to terminate, optionally with a timeout."
 },
 {
  "id": 156,
  "category": "py-conc",
  "q": "What happens to a daemon thread when all non-daemon threads of a Python program have finished?",
  "options": [
   "It is abruptly stopped as the interpreter exits",
   "It keeps running until its function returns",
   "It is converted to a non-daemon thread",
   "The interpreter waits for it and then exits"
  ],
  "correctIndex": 0,
  "explanation": "Daemon threads do not keep the process alive; they are killed abruptly at interpreter shutdown."
 },
 {
  "id": 157,
  "category": "py-conc",
  "q": "How does threading.RLock differ from threading.Lock?",
  "options": [
   "RLock allows multiple threads to hold it simultaneously",
   "RLock works only across processes",
   "The owning thread can acquire an RLock multiple times without deadlocking",
   "RLock never blocks any thread"
  ],
  "correctIndex": 2,
  "explanation": "A reentrant lock tracks owner and recursion count; the same thread may re-acquire it and must release it equally many times."
 },
 {
  "id": 158,
  "category": "py-conc",
  "q": "Output?\nimport threading\nl=threading.Lock()\nl.acquire()\nprint(l.acquire(blocking=False))",
  "options": [
   "True",
   "Blocks forever (deadlock)",
   "Raises RuntimeError",
   "False"
  ],
  "correctIndex": 3,
  "explanation": "A non-blocking acquire on an already-held Lock returns False immediately instead of waiting."
 },
 {
  "id": 159,
  "category": "py-conc",
  "q": "What is the effect of calling time.sleep(2) inside an async def coroutine running on the asyncio event loop?",
  "options": [
   "Only that coroutine pauses; others continue",
   "It blocks the whole event loop for 2 seconds",
   "It raises a RuntimeError",
   "It is automatically converted to await asyncio.sleep(2)"
  ],
  "correctIndex": 1,
  "explanation": "time.sleep is a blocking call; the single-threaded loop cannot run other tasks. Use await asyncio.sleep."
 },
 {
  "id": 160,
  "category": "py-conc",
  "q": "Approximate runtime?\nasync def w(): await asyncio.sleep(1)\nasync def main(): await asyncio.gather(w(), w(), w())\nasyncio.run(main())",
  "options": [
   "About 1 second",
   "About 3 seconds",
   "About 0 seconds",
   "It raises an error because gather needs tasks"
  ],
  "correctIndex": 0,
  "explanation": "gather schedules the coroutines concurrently, so the three 1-second sleeps overlap."
 },
 {
  "id": 161,
  "category": "py-conc",
  "q": "Thread 1 locks A then B; thread 2 locks B then A. Both sometimes hang. What is the standard fix?",
  "options": [
   "Increase the thread priority of one thread",
   "Replace Lock with a global variable flag",
   "Always acquire locks in a single consistent global order",
   "Call sys.setswitchinterval(0)"
  ],
  "correctIndex": 2,
  "explanation": "Opposite acquisition order causes circular wait (deadlock); a consistent lock ordering breaks the cycle."
 },
 {
  "id": 162,
  "category": "py-conc",
  "q": "Which standard-library structure is designed for thread-safe producer-consumer communication?",
  "options": [
   "list with append/pop and no locks",
   "collections.OrderedDict",
   "a plain global dict",
   "queue.Queue"
  ],
  "correctIndex": 3,
  "explanation": "queue.Queue has internal locking and blocking put/get, making it ideal for producer-consumer setups."
 },
 {
  "id": 163,
  "category": "py-conc",
  "q": "Why does Pool().map(lambda x: x*2, range(5)) typically fail with the multiprocessing module?",
  "options": [
   "Lambdas cannot be called with range objects",
   "Lambdas cannot be pickled to send to worker processes",
   "Pool.map only accepts built-in functions",
   "The GIL forbids lambdas in processes"
  ],
  "correctIndex": 1,
  "explanation": "multiprocessing pickles the function to send it to workers; lambdas aren't picklable by the standard pickle."
 },
 {
  "id": 164,
  "category": "py-conc",
  "q": "In CPython, what is the default thread switch interval returned by sys.getswitchinterval()?",
  "options": [
   "0.005 seconds",
   "1 second",
   "0.1 seconds",
   "1 microsecond"
  ],
  "correctIndex": 0,
  "explanation": "The default interval is 5 ms: a thread may be asked to release the GIL after that time when others wait."
 },
 {
  "id": 165,
  "category": "py-conc",
  "q": "A function submitted via ThreadPoolExecutor.submit() raises ValueError. What does future.result() do?",
  "options": [
   "Returns None and logs the error",
   "Returns the ValueError object as a value",
   "Re-raises the ValueError in the calling thread",
   "Terminates the executor silently"
  ],
  "correctIndex": 2,
  "explanation": "Future.result() returns the value or re-raises the exception that occurred inside the submitted callable."
 },
 {
  "id": 166,
  "category": "sql",
  "q": "Which SQL statement removes all rows from a table quickly, keeps the table structure, and is a DDL command in most databases?",
  "options": [
   "DELETE FROM t",
   "TRUNCATE TABLE t",
   "DROP TABLE t",
   "REMOVE FROM t"
  ],
  "correctIndex": 1,
  "explanation": "TRUNCATE TABLE empties the table but keeps its structure. DROP removes the table itself, and DELETE is a DML command that removes rows one by one."
 },
 {
  "id": 167,
  "category": "sql",
  "q": "Which clause is used to filter groups after aggregation, for example keeping only departments with COUNT(*) > 5?",
  "options": [
   "WHERE",
   "GROUP BY",
   "HAVING",
   "ORDER BY"
  ],
  "correctIndex": 2,
  "explanation": "HAVING filters groups after aggregation. WHERE filters rows before grouping."
 },
 {
  "id": 168,
  "category": "sql",
  "q": "Table t(x) holds the values 1, NULL, 3. What does SELECT COUNT(*), COUNT(x) FROM t return?",
  "options": [
   "3, 2",
   "3, 3",
   "2, 2",
   "2, 3"
  ],
  "correctIndex": 0,
  "explanation": "COUNT(*) counts all 3 rows. COUNT(x) ignores NULLs, so it returns 2."
 },
 {
  "id": 169,
  "category": "sql",
  "q": "What does SELECT 'yes' WHERE 1 NOT IN (2, NULL); return?",
  "options": [
   "yes",
   "An error",
   "One row containing NULL",
   "An empty result set"
  ],
  "correctIndex": 3,
  "explanation": "1 <> NULL evaluates to UNKNOWN, so the NOT IN condition is never TRUE and no row is returned."
 },
 {
  "id": 170,
  "category": "sql",
  "q": "In Python's sqlite3, what is the recommended way to prevent SQL injection when using user input?",
  "options": [
   "Parameterized queries: cur.execute('... WHERE id=?', (uid,))",
   "f-strings with quotes around the value",
   "String concatenation using +",
   "Calling str.strip() on the input"
  ],
  "correctIndex": 0,
  "explanation": "Placeholders let the driver pass values separately from the SQL text, so input cannot change the query structure."
 },
 {
  "id": 171,
  "category": "sql",
  "q": "What is printed?\nimport sqlite3\nc=sqlite3.connect(':memory:').cursor()\nc.execute('CREATE TABLE t(a)')\nc.execute('INSERT INTO t VALUES (1)')\nc.execute('SELECT * FROM t')\nprint(c.fetchall())",
  "options": [
   "[1]",
   "[(1,)]",
   "(1,)",
   "[[1]]"
  ],
  "correctIndex": 1,
  "explanation": "fetchall() returns a list of row tuples, so a single-column row appears as (1,)."
 },
 {
  "id": 172,
  "category": "sql",
  "q": "Which query returns the second highest distinct salary from the table emp(salary)?",
  "options": [
   "SELECT MIN(salary) FROM emp",
   "SELECT salary FROM emp ORDER BY salary LIMIT 2",
   "SELECT MAX(salary) FROM emp WHERE salary < (SELECT MAX(salary) FROM emp)",
   "SELECT MAX(salary) - 1 FROM emp"
  ],
  "correctIndex": 2,
  "explanation": "The subquery finds the top salary, and the outer query takes the maximum of the salaries below it."
 },
 {
  "id": 173,
  "category": "sql",
  "q": "Which normal form removes transitive dependencies of non-key attributes on the primary key?",
  "options": [
   "1NF",
   "2NF",
   "BCNF only",
   "3NF"
  ],
  "correctIndex": 3,
  "explanation": "3NF requires that non-key attributes depend only on the key and not on other non-key attributes."
 },
 {
  "id": 174,
  "category": "sql",
  "q": "Which ACID property guarantees that once a transaction is committed, its changes survive a system crash?",
  "options": [
   "Durability",
   "Atomicity",
   "Consistency",
   "Isolation"
  ],
  "correctIndex": 0,
  "explanation": "Durability means committed data is persisted, typically through write-ahead logs, and survives failures."
 },
 {
  "id": 175,
  "category": "sql",
  "q": "Table A has ids 1, 2, 3 and table B has ids 1, 2. How many rows does SELECT * FROM A LEFT JOIN B ON A.id=B.id return?",
  "options": [
   "2",
   "3",
   "5",
   "6"
  ],
  "correctIndex": 1,
  "explanation": "A LEFT JOIN keeps all 3 rows of A. Ids 1 and 2 each match one row in B, and id 3 gets NULLs."
 },
 {
  "id": 176,
  "category": "sql",
  "q": "Table A has the values 1, 2, 2 and table B has 2, 3. How many rows does SELECT x FROM A UNION SELECT x FROM B return?",
  "options": [
   "5",
   "4",
   "3",
   "2"
  ],
  "correctIndex": 2,
  "explanation": "UNION removes duplicates, so the result is {1, 2, 3}, which is 3 rows."
 },
 {
  "id": 177,
  "category": "sql",
  "q": "Salaries are 100, 100, 90. What is RANK() OVER (ORDER BY salary DESC) for the row with salary 90?",
  "options": [
   "1",
   "2",
   "4",
   "3"
  ],
  "correctIndex": 3,
  "explanation": "RANK leaves gaps after ties: the two 100s both get rank 1, so 90 gets rank 3. DENSE_RANK would give 2."
 },
 {
  "id": 178,
  "category": "sql",
  "q": "What is a common drawback of creating many indexes on a table?",
  "options": [
   "Slower INSERT, UPDATE and DELETE and more storage",
   "Slower SELECT queries on indexed columns",
   "Loss of primary key uniqueness",
   "Tables can no longer be joined"
  ],
  "correctIndex": 0,
  "explanation": "Every write must also update each index, which costs time and disk space."
 },
 {
  "id": 179,
  "category": "sql",
  "q": "In Python's sqlite3, after executing an INSERT through a connection conn, which call makes the change permanent?",
  "options": [
   "cur.close()",
   "conn.commit()",
   "conn.flush()",
   "cur.fetchall()"
  ],
  "correctIndex": 1,
  "explanation": "DML statements run inside a transaction that must be committed with conn.commit(). Otherwise the change is lost on close or rollback."
 },
 {
  "id": 180,
  "category": "sql",
  "q": "In Python's sqlite3, what does a 'with conn:' block do when it exits without an exception?",
  "options": [
   "Closes the connection",
   "Drops the temporary tables",
   "Commits the transaction without closing the connection",
   "Does nothing and leaves the transaction open"
  ],
  "correctIndex": 2,
  "explanation": "The connection works as a transaction context manager: it commits on success and rolls back on exception, but it does not close."
 },
 {
  "id": 181,
  "category": "sql",
  "q": "What is a deadlock in a database?",
  "options": [
   "A query that runs for a long time",
   "A table locked by a backup job",
   "A transaction that rolls back after an error",
   "Two transactions each waiting for a lock held by the other"
  ],
  "correctIndex": 3,
  "explanation": "A deadlock is a circular wait between transactions, and the DBMS resolves it by aborting one of them."
 },
 {
  "id": 182,
  "category": "sql",
  "q": "Which statement about keys is correct?",
  "options": [
   "A table can have many UNIQUE constraints but only one PRIMARY KEY",
   "A table can have many PRIMARY KEYs",
   "PRIMARY KEY columns may contain NULLs",
   "UNIQUE columns can never be indexed"
  ],
  "correctIndex": 0,
  "explanation": "A table has exactly one primary key, which is not NULL and unique, but it can have several UNIQUE constraints."
 },
 {
  "id": 183,
  "category": "sql",
  "q": "Column x contains 1, 1, NULL, 2. What does SELECT COUNT(DISTINCT x) FROM t return?",
  "options": [
   "4",
   "2",
   "3",
   "1"
  ],
  "correctIndex": 1,
  "explanation": "COUNT(DISTINCT x) ignores NULLs and counts the distinct values 1 and 2."
 },
 {
  "id": 184,
  "category": "sql",
  "q": "What is printed?\nimport sqlite3\nc=sqlite3.connect(':memory:').cursor()\nc.execute('SELECT 1 UNION SELECT 1 UNION SELECT 2')\nprint(len(c.fetchall()))",
  "options": [
   "3",
   "1",
   "2",
   "0"
  ],
  "correctIndex": 2,
  "explanation": "UNION removes the duplicate 1, leaving the rows 1 and 2, so the length is 2."
 },
 {
  "id": 185,
  "category": "sql",
  "q": "Which problem occurs when a transaction reads data that another transaction has written but not yet committed?",
  "options": [
   "Phantom read",
   "Lost update",
   "Non-repeatable read",
   "Dirty read"
  ],
  "correctIndex": 3,
  "explanation": "A dirty read sees uncommitted changes. The READ COMMITTED isolation level and above prevent it."
 },
 {
  "id": 186,
  "category": "dsa-core",
  "q": "What is the time complexity of list.insert(0, x) on a Python list with n elements?",
  "options": [
   "O(n)",
   "O(1)",
   "O(log n)",
   "O(n log n)"
  ],
  "correctIndex": 0,
  "explanation": "Inserting at index 0 shifts all n existing elements one position right."
 },
 {
  "id": 187,
  "category": "dsa-core",
  "q": "What is the output of print(\"hello\"[::-1])?",
  "options": [
   "hello",
   "Error",
   "olleh",
   "oellh"
  ],
  "correctIndex": 2,
  "explanation": "A slice with step -1 traverses the string backwards, reversing it."
 },
 {
  "id": 188,
  "category": "dsa-core",
  "q": "What is the output?\na = [1, 2, 3, 4, 5]\nprint(a[1:4])",
  "options": [
   "[1, 2, 3, 4]",
   "[1, 2, 3]",
   "[2, 3, 4, 5]",
   "[2, 3, 4]"
  ],
  "correctIndex": 3,
  "explanation": "Slicing includes the start index 1 and excludes the end index 4, giving elements at indices 1, 2, 3."
 },
 {
  "id": 189,
  "category": "dsa-core",
  "q": "What is the optimal average time complexity to solve the Two Sum problem on an unsorted array using a hash map?",
  "options": [
   "O(n^2)",
   "O(n)",
   "O(n log n)",
   "O(log n)"
  ],
  "correctIndex": 1,
  "explanation": "One pass, with O(1) average lookup for each complement in the dictionary."
 },
 {
  "id": 190,
  "category": "dsa-core",
  "q": "What is the output?\nm = [[0]*3]*2\nm[0][0] = 1\nprint(m)",
  "options": [
   "[[1, 0, 0], [0, 0, 0]]",
   "[[0, 0, 0], [1, 0, 0]]",
   "[[1, 0, 0], [1, 0, 0]]",
   "Error"
  ],
  "correctIndex": 2,
  "explanation": "[[0]*3]*2 repeats a reference to the same inner list, so both rows change."
 },
 {
  "id": 191,
  "category": "dsa-core",
  "q": "What happens when you run?\ns = \"abc\"\ns[0] = 'x'",
  "options": [
   "TypeError",
   "s becomes 'xbc'",
   "IndexError",
   "s stays 'abc' silently"
  ],
  "correctIndex": 0,
  "explanation": "Python strings are immutable, so item assignment raises TypeError."
 },
 {
  "id": 192,
  "category": "dsa-core",
  "q": "What is the maximum subarray sum (Kadane's algorithm) for [-2, 1, -3, 4, -1, 2, 1, -5, 4]?",
  "options": [
   "4",
   "5",
   "7",
   "6"
  ],
  "correctIndex": 3,
  "explanation": "The subarray [4, -1, 2, 1] has the maximum sum, 6."
 },
 {
  "id": 193,
  "category": "dsa-core",
  "q": "In the worst case, about how many comparisons does binary search need on a sorted array of 1000 elements?",
  "options": [
   "500",
   "10",
   "1000",
   "100"
  ],
  "correctIndex": 1,
  "explanation": "Binary search needs at most floor(log2(1000)) + 1 = 10 comparisons."
 },
 {
  "id": 194,
  "category": "dsa-core",
  "q": "What is the output of print(sorted(\"bca\", reverse=True))?",
  "options": [
   "['a', 'b', 'c']",
   "'cba'",
   "['c', 'b', 'a']",
   "('c', 'b', 'a')"
  ],
  "correctIndex": 2,
  "explanation": "sorted() always returns a list of characters, here in descending order."
 },
 {
  "id": 195,
  "category": "dsa-core",
  "q": "What is the output?\na = [1, 2, 3]\nprint(a.pop(), a)",
  "options": [
   "3 [1, 2]",
   "1 [2, 3]",
   "3 [1, 2, 3]",
   "[1, 2] 3"
  ],
  "correctIndex": 0,
  "explanation": "pop() removes and returns the last element, 3, before a is evaluated, so a is [1, 2]."
 },
 {
  "id": 196,
  "category": "dsa-core",
  "q": "Which approach rotates an array of n elements by k positions in place with optimal time and space?",
  "options": [
   "Shift one by one: O(n*k) time, O(1) space",
   "Extra array: O(n) time, O(n) space",
   "Sort-based: O(n log n) time, O(1) space",
   "Three reversals: O(n) time, O(1) space"
  ],
  "correctIndex": 3,
  "explanation": "Reverse the first part, then the second part, then the whole array, in O(n) time and O(1) space."
 },
 {
  "id": 197,
  "category": "dsa-core",
  "q": "An array holds n distinct numbers from 0..n, with one missing. Which finds it in O(n) time and O(1) space?",
  "options": [
   "Sort and scan",
   "Store in a hash set",
   "n(n+1)/2 minus sum of array",
   "Nested loop search"
  ],
  "correctIndex": 2,
  "explanation": "The expected sum minus the actual sum equals the missing number, with no extra storage."
 },
 {
  "id": 198,
  "category": "dsa-core",
  "q": "What is the output of print(len(set(\"mississippi\")))?",
  "options": [
   "3",
   "4",
   "11",
   "5"
  ],
  "correctIndex": 1,
  "explanation": "The unique characters are m, i, s and p, so the set has 4 elements."
 },
 {
  "id": 199,
  "category": "dsa-core",
  "q": "What is the output?\na = [3, 1, 2]\nb = sorted(a)\nprint(a, b)",
  "options": [
   "[3, 1, 2] [1, 2, 3]",
   "[1, 2, 3] [1, 2, 3]",
   "[1, 2, 3] [3, 1, 2]",
   "None [1, 2, 3]"
  ],
  "correctIndex": 0,
  "explanation": "sorted() returns a new list and leaves the original unchanged."
 },
 {
  "id": 200,
  "category": "dsa-core",
  "q": "What is the best time complexity to check whether two strings of length n are anagrams using a frequency counter?",
  "options": [
   "O(n^2)",
   "O(n log n)",
   "O(log n)",
   "O(n)"
  ],
  "correctIndex": 3,
  "explanation": "Counting characters in both strings takes one linear pass each, so O(n)."
 },
 {
  "id": 201,
  "category": "dsa-core",
  "q": "What is the output?\nx = [[1], [2]]\ny = x[:]\ny[0].append(5)\nprint(x)",
  "options": [
   "[[1], [2]]",
   "[[1, 5], [2]]",
   "[[1, 5], [2, 5]]",
   "[[5], [2]]"
  ],
  "correctIndex": 1,
  "explanation": "x[:] makes a shallow copy, so the inner lists are shared and the append shows up in x."
 },
 {
  "id": 202,
  "category": "dsa-core",
  "q": "What is the length of the longest substring without repeating characters in \"pwwkew\"?",
  "options": [
   "2",
   "4",
   "3",
   "6"
  ],
  "correctIndex": 2,
  "explanation": "The longest such substring is \"wke\" (or \"kew\"), with length 3."
 },
 {
  "id": 203,
  "category": "dsa-core",
  "q": "Which algorithm sorts an array of only 0s, 1s and 2s in a single pass with O(1) extra space?",
  "options": [
   "Dutch National Flag (three pointers)",
   "Merge sort",
   "Counting sort with a hash map",
   "Binary search"
  ],
  "correctIndex": 0,
  "explanation": "The Dutch National Flag algorithm uses low, mid and high pointers to partition the array in one pass."
 },
 {
  "id": 204,
  "category": "dsa-core",
  "q": "What is the output?\nprint([i*i for i in range(5) if i % 2 == 0])",
  "options": [
   "[0, 1, 4, 9, 16]",
   "[0, 2, 4]",
   "[1, 9]",
   "[0, 4, 16]"
  ],
  "correctIndex": 3,
  "explanation": "Only the even i values 0, 2, 4 pass the filter, and their squares are 0, 4, 16."
 },
 {
  "id": 205,
  "category": "dsa-core",
  "q": "What is the output?\na = [1, 2, 3]\na.extend([4, 5])\na.append([6])\nprint(len(a))",
  "options": [
   "5",
   "6",
   "7",
   "8"
  ],
  "correctIndex": 1,
  "explanation": "extend adds 4 and 5 as separate items, append adds the list [6] as one item, so the length is 3+2+1 = 6."
 },
 {
  "id": 206,
  "category": "dsa-core",
  "q": "What is the output?\nprint(\"a,b,,c\".split(\",\"))",
  "options": [
   "['a', 'b', 'c']",
   "['a', 'b', ',', 'c']",
   "['a,b', ',c']",
   "['a', 'b', '', 'c']"
  ],
  "correctIndex": 3,
  "explanation": "split with an explicit separator keeps empty strings between adjacent separators."
 },
 {
  "id": 207,
  "category": "dsa-core",
  "q": "Which is the most efficient, idiomatic way in Python to build one string from a list of n strings?",
  "options": [
   "''.join(lst)",
   "Loop with s += item for each item",
   "Recursively concatenate with +",
   "Use reduce with the + operator"
  ],
  "correctIndex": 0,
  "explanation": "join computes the total size once and builds the result in O(n), whereas repeated + can degrade to O(n^2)."
 },
 {
  "id": 208,
  "category": "dsa-core",
  "q": "What is the optimal time complexity of the sliding window maximum problem (window size k) using a monotonic deque?",
  "options": [
   "O(n*k)",
   "O(n)",
   "O(n log k)",
   "O(k log n)"
  ],
  "correctIndex": 1,
  "explanation": "Each element is pushed to and popped from the deque at most once, giving O(n) overall."
 },
 {
  "id": 209,
  "category": "dsa-core",
  "q": "What is the output?\nprint(list(range(10, 0, -3)))",
  "options": [
   "[10, 7, 4, 1]",
   "[10, 7, 4]",
   "[7, 4, 1]",
   "[10, 7, 4, 1, -2]"
  ],
  "correctIndex": 0,
  "explanation": "range starts at 10 and steps by -3 while the value is greater than 0, giving 10, 7, 4, 1."
 },
 {
  "id": 210,
  "category": "dsa-core",
  "q": "An array of n+1 integers in the range 1..n has one repeated number. Which finds it in O(n) time and O(1) space without modifying the array?",
  "options": [
   "Sort the array and compare neighbours",
   "Store seen values in a hash set",
   "Use two nested loops to compare pairs",
   "Floyd's cycle detection (tortoise and hare)"
  ],
  "correctIndex": 3,
  "explanation": "Treating values as next pointers forms a cycle whose entry point is the duplicate; Floyd's method finds it in O(n) time and O(1) space."
 },
 {
  "id": 211,
  "category": "dsa-core",
  "q": "What is the output?\na = [1, 2, 2, 3]\nfor x in a:\n    if x == 2:\n        a.remove(x)\nprint(a)",
  "options": [
   "[1, 3]",
   "[1, 2, 2, 3]",
   "[1, 2, 3]",
   "IndexError"
  ],
  "correctIndex": 2,
  "explanation": "Removing during iteration shifts elements, so the loop skips the second 2 and only one 2 is removed."
 },
 {
  "id": 212,
  "category": "dsa-core",
  "q": "What is the output?\na = [5, 3, 8]\nprint(max(a, key=lambda x: -x))",
  "options": [
   "8",
   "3",
   "5",
   "-3"
  ],
  "correctIndex": 1,
  "explanation": "The key negates values, so the maximum key (-3) belongs to the element 3, and max returns the original element."
 },
 {
  "id": 213,
  "category": "dsa-core",
  "q": "Which technique solves the 'Next Greater Element' problem for every element of an array in O(n) time?",
  "options": [
   "Monotonic stack",
   "Nested loops over all pairs",
   "Sorting then binary search per element",
   "A min-heap rebuilt for each element"
  ],
  "correctIndex": 0,
  "explanation": "A monotonic stack pops smaller elements when a greater one arrives, so each element is pushed and popped once."
 },
 {
  "id": 214,
  "category": "dsa-core",
  "q": "What is the output?\n\na = [[0] * 2] * 2\na[0][0] = 1\nprint(a)",
  "options": [
   "[[1, 0], [0, 0]]",
   "[[1, 0], [1, 0]]",
   "[[1, 0]]",
   "[[0, 0], [0, 0]]"
  ],
  "correctIndex": 1,
  "explanation": "The outer * 2 repeats a reference to the same inner list, so both rows are one object and the change shows in both."
 },
 {
  "id": 215,
  "category": "dsa-core",
  "q": "What is the output?\n\na = [1, 2, 3, 4, 5]\nprint(a[-2:] + a[:-2])",
  "options": [
   "[4, 5, 1, 2, 3]",
   "[3, 4, 5, 1, 2]",
   "[2, 3, 4, 5, 1]",
   "[1, 2, 3, 4, 5]"
  ],
  "correctIndex": 0,
  "explanation": "a[-2:] is [4, 5] and a[:-2] is [1, 2, 3], so concatenating them rotates the list right by 2."
 },
 {
  "id": 216,
  "category": "dsa-adv",
  "q": "Which traversal of a Binary Search Tree visits the keys in ascending sorted order?",
  "options": [
   "Preorder",
   "Inorder",
   "Postorder",
   "Level order"
  ],
  "correctIndex": 1,
  "explanation": "Inorder visits left subtree, node, then right subtree, which gives sorted order for a BST."
 },
 {
  "id": 217,
  "category": "dsa-adv",
  "q": "What is the maximum number of nodes in a binary tree of height h, where a single root node has height 0?",
  "options": [
   "2^h",
   "2^h - 1",
   "2^(h+1) - 1",
   "h^2 + 1"
  ],
  "correctIndex": 2,
  "explanation": "Each level i holds at most 2^i nodes, and the sum for i=0..h is 2^(h+1)-1."
 },
 {
  "id": 218,
  "category": "dsa-adv",
  "q": "What is the time complexity of BFS on a graph stored as an adjacency list, with V vertices and E edges?",
  "options": [
   "O(V*E)",
   "O(V^2)",
   "O(E log V)",
   "O(V + E)"
  ],
  "correctIndex": 3,
  "explanation": "Each vertex is enqueued once and each edge is examined a constant number of times, so the cost is O(V+E)."
 },
 {
  "id": 219,
  "category": "dsa-adv",
  "q": "Output?\nfrom collections import deque\ng={0:[1,2],1:[3],2:[3],3:[]}\nq=deque([0]);s={0};o=[]\nwhile q:\n n=q.popleft();o.append(n)\n for m in g[n]:\n  if m not in s:s.add(m);q.append(m)\nprint(o)",
  "options": [
   "[0, 1, 3, 2]",
   "[0, 1, 2, 3]",
   "[0, 2, 1, 3]",
   "[0, 1, 2, 3, 3]"
  ],
  "correctIndex": 1,
  "explanation": "BFS visits level by level: 0, then 1 and 2, then 3, which is added only once because of the visited set."
 },
 {
  "id": 220,
  "category": "dsa-adv",
  "q": "A skewed BST is built by inserting 1,2,3,4,5 in order. With h(None)=0 and h(n)=1+max(h(left),h(right)), what does h(root) return?",
  "options": [
   "3",
   "4",
   "5",
   "2"
  ],
  "correctIndex": 2,
  "explanation": "Sorted insertion creates a right-leaning chain of 5 nodes, so the height counted in nodes is 5."
 },
 {
  "id": 221,
  "category": "dsa-adv",
  "q": "Which data structure makes Dijkstra's algorithm run in O((V+E) log V) on an adjacency-list graph?",
  "options": [
   "Stack",
   "FIFO queue",
   "Min-heap (priority queue)",
   "Hash set"
  ],
  "correctIndex": 2,
  "explanation": "A min-heap extracts the closest unvisited vertex in O(log V), and Python's heapq provides this."
 },
 {
  "id": 222,
  "category": "dsa-adv",
  "q": "Which technique correctly detects a cycle in a directed graph?",
  "options": [
   "DFS tracking nodes on the current recursion stack",
   "BFS checking only whether a node was visited",
   "Counting edges and comparing with V",
   "Inorder traversal"
  ],
  "correctIndex": 0,
  "explanation": "A back edge to a node still on the recursion stack (a gray node) indicates a directed cycle; plain visited checks give false positives."
 },
 {
  "id": 223,
  "category": "dsa-adv",
  "q": "Output?\ncoins=[1,3,4];n=6\ndp=[0]+[99]*n\nfor a in range(1,n+1):\n for c in coins:\n  if c<=a: dp[a]=min(dp[a],dp[a-c]+1)\nprint(dp[n])",
  "options": [
   "3",
   "1",
   "4",
   "2"
  ],
  "correctIndex": 3,
  "explanation": "The minimum for 6 is 3+3, which uses 2 coins. Greedy 4+1+1 would use 3 coins."
 },
 {
  "id": 224,
  "category": "dsa-adv",
  "q": "What is the length of the Longest Common Subsequence of \"ABCBDAB\" and \"BDCABA\"?",
  "options": [
   "3",
   "4",
   "5",
   "6"
  ],
  "correctIndex": 1,
  "explanation": "This is the classic CLRS example, with LCS such as BCBA of length 4."
 },
 {
  "id": 225,
  "category": "dsa-adv",
  "q": "A topological ordering of a directed graph exists if and only if the graph is:",
  "options": [
   "Connected",
   "Bipartite",
   "A tree",
   "A DAG (acyclic)"
  ],
  "correctIndex": 3,
  "explanation": "A cycle makes it impossible to place every vertex before the vertices it points to; DAGs always have a valid order."
 },
 {
  "id": 226,
  "category": "dsa-adv",
  "q": "How many edges does a minimum spanning tree of a connected graph with V vertices have?",
  "options": [
   "V - 1",
   "V",
   "V + 1",
   "E - 1"
  ],
  "correctIndex": 0,
  "explanation": "A spanning tree connects all V vertices with no cycles, which takes exactly V-1 edges."
 },
 {
  "id": 227,
  "category": "dsa-adv",
  "q": "Kruskal's MST algorithm typically uses which data structure to avoid forming cycles?",
  "options": [
   "Disjoint Set Union (Union-Find)",
   "Trie",
   "Segment tree",
   "Monotonic stack"
  ],
  "correctIndex": 0,
  "explanation": "Union-Find checks in near O(1) time whether an edge's endpoints are already in the same component."
 },
 {
  "id": 228,
  "category": "dsa-adv",
  "q": "What is the time complexity of the standard 0/1 Knapsack DP for n items and capacity W?",
  "options": [
   "O(n log W)",
   "O(2^n)",
   "O(n + W)",
   "O(n*W)"
  ],
  "correctIndex": 3,
  "explanation": "The table has n*W states with O(1) work each; this is pseudo-polynomial in W."
 },
 {
  "id": 229,
  "category": "dsa-adv",
  "q": "Output?\ndp=[[1]*3 for _ in range(3)]\nfor i in range(1,3):\n for j in range(1,3):\n  dp[i][j]=dp[i-1][j]+dp[i][j-1]\nprint(dp[2][2])",
  "options": [
   "4",
   "6",
   "8",
   "9"
  ],
  "correctIndex": 1,
  "explanation": "This counts grid paths for a 3x3 grid, which is C(4,2)=6."
 },
 {
  "id": 230,
  "category": "dsa-adv",
  "q": "In a full binary tree (every node has 0 or 2 children) with n internal nodes, how many leaf nodes are there?",
  "options": [
   "n - 1",
   "n",
   "2n",
   "n + 1"
  ],
  "correctIndex": 3,
  "explanation": "Total nodes are 2n+1, so leaves = (2n+1) - n = n+1."
 },
 {
  "id": 231,
  "category": "dsa-adv",
  "q": "Which algorithm finds single-source shortest paths when edges may have negative weights (no negative cycle)?",
  "options": [
   "Dijkstra",
   "Bellman-Ford",
   "Prim",
   "Kruskal"
  ],
  "correctIndex": 1,
  "explanation": "Bellman-Ford relaxes all edges V-1 times in O(VE) and handles negative weights; Dijkstra can fail with them."
 },
 {
  "id": 232,
  "category": "dsa-adv",
  "q": "Which pair of traversals uniquely identifies a binary tree with distinct keys?",
  "options": [
   "Preorder and postorder",
   "Preorder only",
   "Level order only",
   "Inorder and preorder"
  ],
  "correctIndex": 3,
  "explanation": "Preorder gives the root and inorder splits left and right subtrees; preorder with postorder is ambiguous."
 },
 {
  "id": 233,
  "category": "dsa-adv",
  "q": "How many structurally distinct BSTs can be formed with 4 distinct keys?",
  "options": [
   "14",
   "12",
   "16",
   "24"
  ],
  "correctIndex": 0,
  "explanation": "The count is the Catalan number C4 = (1/5)*C(8,4) = 14."
 },
 {
  "id": 234,
  "category": "dsa-adv",
  "q": "Output?\nn=6;e=[(0,1),(1,2),(3,4)];p=list(range(n))\ndef f(x):\n while p[x]!=x: x=p[x]\n return x\nfor a,b in e: p[f(a)]=f(b)\nprint(len({f(i) for i in range(n)}))",
  "options": [
   "2",
   "6",
   "4",
   "3"
  ],
  "correctIndex": 3,
  "explanation": "The components are {0,1,2}, {3,4} and {5}, so there are 3 distinct roots."
 },
 {
  "id": 235,
  "category": "dsa-adv",
  "q": "Memoizing recursive Fibonacci with functools.lru_cache reduces the time complexity from exponential to:",
  "options": [
   "O(log n)",
   "O(n)",
   "O(n log n)",
   "O(n^2)"
  ],
  "correctIndex": 1,
  "explanation": "Each of the n distinct subproblems is computed once in O(1) time, so the total is O(n)."
 },
 {
  "id": 236,
  "category": "dsa-adv",
  "q": "Output?\na=[10,9,2,5,3,7,101,18]\ndp=[1]*len(a)\nfor i in range(len(a)):\n for j in range(i):\n  if a[j]<a[i]: dp[i]=max(dp[i],dp[j]+1)\nprint(max(dp))",
  "options": [
   "3",
   "5",
   "4",
   "6"
  ],
  "correctIndex": 2,
  "explanation": "This is the O(n^2) LIS DP; one longest increasing subsequence is 2,3,7,18 (or 2,5,7,18), so the length is 4."
 },
 {
  "id": 237,
  "category": "dsa-adv",
  "q": "Keys 8,3,10,1,6,14,4,7 are inserted into an empty BST in this order. What is the lowest common ancestor of nodes 4 and 7?",
  "options": [
   "3",
   "6",
   "8",
   "4"
  ],
  "correctIndex": 1,
  "explanation": "Node 6 has 4 in its left subtree and 7 in its right subtree, so 6 is the first node where the two keys split."
 },
 {
  "id": 238,
  "category": "dsa-adv",
  "q": "What is the minimum edit distance (insert, delete, replace) to convert \"horse\" into \"ros\"?",
  "options": [
   "3",
   "2",
   "4",
   "5"
  ],
  "correctIndex": 0,
  "explanation": "horse -> rorse (replace h) -> rose (delete r) -> ros (delete e) takes 3 operations, and the DP table confirms 3 is the minimum."
 },
 {
  "id": 239,
  "category": "dsa-adv",
  "q": "Output?\na=[2,7,9,3,1]\np=c=0\nfor x in a:\n p,c=c,max(c,p+x)\nprint(c)",
  "options": [
   "11",
   "10",
   "13",
   "12"
  ],
  "correctIndex": 3,
  "explanation": "This is House Robber: the best non-adjacent sum is 2+9+1=12, and c evolves 2,7,11,11,12."
 },
 {
  "id": 240,
  "category": "dsa-adv",
  "q": "A connected undirected graph is bipartite (2-colorable) if and only if it contains no:",
  "options": [
   "Even-length cycle",
   "Self-loop only",
   "Odd-length cycle",
   "Cycle of any length"
  ],
  "correctIndex": 2,
  "explanation": "BFS/DFS 2-coloring fails exactly when an odd-length cycle exists, and even cycles are fine for bipartite graphs."
 },
 {
  "id": 241,
  "category": "os-cn",
  "q": "Which CPU scheduling algorithm can cause starvation of long processes if short processes keep arriving?",
  "options": [
   "First Come First Served",
   "Round Robin",
   "Shortest Job First",
   "Multilevel feedback with aging"
  ],
  "correctIndex": 2,
  "explanation": "SJF always picks the shortest burst, so a long job may wait indefinitely; FCFS and RR are starvation-free and aging prevents it."
 },
 {
  "id": 242,
  "category": "os-cn",
  "q": "Which Python call creates a UDP socket?",
  "options": [
   "socket.socket(socket.AF_INET, socket.SOCK_STREAM)",
   "socket.socket(socket.AF_INET, socket.SOCK_DGRAM)",
   "socket.socket(socket.AF_INET, socket.SOCK_RAW)",
   "socket.socket(socket.AF_UNIX, socket.SOCK_STREAM)"
  ],
  "correctIndex": 1,
  "explanation": "SOCK_DGRAM over AF_INET gives a UDP datagram socket; SOCK_STREAM is TCP."
 },
 {
  "id": 243,
  "category": "os-cn",
  "q": "Which of the following is NOT a necessary condition for deadlock?",
  "options": [
   "Mutual exclusion",
   "Hold and wait",
   "Circular wait",
   "Preemption of resources"
  ],
  "correctIndex": 3,
  "explanation": "Deadlock requires NO preemption; if resources can be preempted, deadlock can be broken."
 },
 {
  "id": 244,
  "category": "os-cn",
  "q": "On Linux, how many times is 'A' printed?\nimport os\nos.fork()\nos.fork()\nprint('A')",
  "options": [
   "2",
   "3",
   "4",
   "8"
  ],
  "correctIndex": 2,
  "explanation": "Each fork doubles the number of processes: 1 -> 2 -> 4, and every process runs print once."
 },
 {
  "id": 245,
  "category": "os-cn",
  "q": "Why does multithreading in CPython usually give no speedup for CPU-bound tasks?",
  "options": [
   "The GIL lets only one thread execute Python bytecode at a time",
   "Python threads are simulated and not real OS threads",
   "Threads in Python cannot share memory",
   "The OS allows only one thread per Python process"
  ],
  "correctIndex": 0,
  "explanation": "The Global Interpreter Lock serializes bytecode execution; use multiprocessing for CPU-bound work."
 },
 {
  "id": 246,
  "category": "os-cn",
  "q": "Belady's anomaly (more frames causing more page faults) can occur with which page replacement algorithm?",
  "options": [
   "LRU",
   "FIFO",
   "Optimal",
   "Any stack-based algorithm"
  ],
  "correctIndex": 1,
  "explanation": "FIFO is not a stack algorithm, so it can show Belady's anomaly; LRU and Optimal cannot."
 },
 {
  "id": 247,
  "category": "os-cn",
  "q": "How many usable host addresses are available in a /26 IPv4 subnet?",
  "options": [
   "30",
   "64",
   "126",
   "62"
  ],
  "correctIndex": 3,
  "explanation": "A /26 has 6 host bits: 2^6 = 64 addresses, minus network and broadcast = 62 usable."
 },
 {
  "id": 248,
  "category": "os-cn",
  "q": "What is the correct order of packets in the TCP three-way handshake?",
  "options": [
   "SYN, SYN-ACK, ACK",
   "SYN, ACK, SYN-ACK",
   "ACK, SYN, FIN",
   "SYN, FIN, ACK"
  ],
  "correctIndex": 0,
  "explanation": "Client sends SYN, server replies SYN-ACK, client confirms with ACK."
 },
 {
  "id": 249,
  "category": "os-cn",
  "q": "What does this print?\nimport subprocess\nr = subprocess.run(['python', '-c', 'import sys; sys.exit(3)'])\nprint(r.returncode)",
  "options": [
   "0",
   "1",
   "3",
   "None"
  ],
  "correctIndex": 2,
  "explanation": "The child exits with status 3, and subprocess.run stores it in CompletedProcess.returncode."
 },
 {
  "id": 250,
  "category": "os-cn",
  "q": "A system has 32-bit virtual addresses and 4 KB pages. How many entries does a single-level page table need?",
  "options": [
   "2^10",
   "2^20",
   "2^12",
   "2^32"
  ],
  "correctIndex": 1,
  "explanation": "4 KB = 2^12 offset bits, leaving 32 - 12 = 20 bits for the page number, so 2^20 entries."
 }
];
export const CATEGORIES = [
 {
  "id": "py-core",
  "label": "Python Fundamentals",
  "count": 40
 },
 {
  "id": "py-ds",
  "label": "Lists, Dicts, Sets & Tuples",
  "count": 30
 },
 {
  "id": "py-oop",
  "label": "OOP in Python",
  "count": 25
 },
 {
  "id": "py-func",
  "label": "Functions, Decorators & Generators",
  "count": 25
 },
 {
  "id": "py-exc",
  "label": "Exceptions & File Handling",
  "count": 15
 },
 {
  "id": "py-stdlib",
  "label": "Modules & Standard Library",
  "count": 15
 },
 {
  "id": "py-conc",
  "label": "Concurrency & the GIL",
  "count": 15
 },
 {
  "id": "sql",
  "label": "SQL & Database",
  "count": 20
 },
 {
  "id": "dsa-core",
  "label": "DSA - Arrays/Strings/Lists",
  "count": 30
 },
 {
  "id": "dsa-adv",
  "label": "DSA - Trees/Graphs/DP",
  "count": 25
 },
 {
  "id": "os-cn",
  "label": "OS & Networking",
  "count": 10
 }
];
